import { QueryViewTypes, PIViewTypes, MainViewTypes } from './data';
import meshCode2NameJson from './clinical_trial_field_code_to_name.json';
import paperFieldCode2NameJson from './paper_field_code_to_name.json';

export const systemName: string = 'FundingTheFrontier'

export const yearRange: [number, number] = [2000, 2021]
export const numBinGlyph: number = 10

export const caseType: string = 'case1' // 'case1' or 'case2'

export enum ImpactType {
	DIRECT_IMPACT = 'direct_impact',
	INDIRECT_IMPACT_FOLDED = 'indirect_impact_folded',
	INDIRECT_IMPACT_UNFOLDED = 'indirected_impact_unfolded',
	// DIRECT_IMPACT = 'Direct Output',
	// INDIRECT_IMPACT_FOLDED = 'Broad Impact (folded)',
	// INDIRECT_IMPACT_UNFOLDED = 'Broad Impact (unfolded)',
}
export enum GrantGlyphType {
  RCIGLYPH = 'Impact Glyph',
  IMPACTCOUNTGLYPH = 'ImpactCount Glyph',
  PREDICTIONGLYPH = 'Prediction Glyph',
}
export enum CitationFlowType {
	HISTORICAL = 'Historical Facts',
	PREDICTION = 'Investment Recommendation',
}

export const impactEntityList = {
  directImpact: ['paper', 'patent', 'clinical_trial'],
  indirectImpactFolded: ['patent', 'clinical_trial', 'policy', 'newsfeed'],
  indirectImpactUnfolded: ['paper', 'patent', 'clincial_trial', 'policy', 'newsfeed'],
}

export enum EntityType {
	GRANT = 'grant',
	PAPER = 'paper',
	PATENT = 'patent',
	CLINICAL_TRIAL = 'clinical_trial',
	POLICY = 'policy',
	NEWSFEED = 'newsfeed',
}

export enum ImpactStatisticsType {
	NUM_PAPER = 'scientific impact (num_paper)',
	NUM_HIT_PAPER = 'scientific impact (num_hit_paper)',
	NUM_DISRUPTIVE_PAPER = 'scientific impact (num_disruptive_paper)',
	NUM_PATENT = 'marketplace impact (num_patent)',
	NUM_CLINICAL_TRIAL = 'medicine impact (num_clinical_trial)',
	NUM_CITING_PATENT = 'marketplace impact (num_citing_patent)',
	NUM_CITING_CLINICAL_TRIAL = 'medicine impact (num_citing_clinical_trial)',
	NUM_CITING_POLICY = 'policy impact (num_citing_policy)',
	NUM_CITING_NEWSFEED = 'media impact (num_citing_newsfeed)',
}

export enum ImpactStatisticsEntityType {
	NUM_PAPER = 'paper',
	NUM_HIT_PAPER = 'hit_paper',
	NUM_DISRUPTIVE_PAPER = 'disruptive_paper',
	NUM_PATENT = 'patent',
	NUM_CLINICAL_TRIAL = 'clinical_trial',
	NUM_CITING_PATENT = 'patent',
	NUM_CITING_CLINICAL_TRIAL = 'clinical_trial',
	NUM_CITING_POLICY = 'policy',
	NUM_CITING_NEWSFEED = 'newsfeed',
}

export enum ClinicalTrialImpactAttr {
	PHASE = 'Phase',
	TYPE = 'Type',
}

export enum CPCFieldLevelList {
  CPCROOT = 'cpcRoot',
  CPCSECTION = 'cpcSection',
  CPCSUBSECTION = 'cpcSubsection',
  CPCGROUP = 'cpcGroup',
}

export enum PICardSortMetric {
	HINDEX = 'h-index',
	PRODUCTIVITY = 'productivity',
	TOTALPUBLICATIONS = 'total pubications',
	TOTALGRANTS = 'total grants',
	PSCORE = 'prediction score',
}


// ===== caseType: "case1" (start) =====
// --- QueryView ---
export const funderOrganizationHierarchy: QueryViewTypes.FunderOrganizationHierarchy[] = [
	{
		self: {
			funderGridID: 'grid.94365.3d',
			funderName: 'National Institutes of Health',
		},
		childrenList: [{
			funderGridID: 'grid.419475.a',
			funderName: 'National Institute on Aging'
		},
    {
			funderGridID: 'grid.280030.9',
			funderName: 'National Eye Institute'
		},
    {
			funderGridID: 'grid.280128.1',
			funderName: 'National Human Genome Research Institute'
		},
    {
			funderGridID: 'grid.279885.9',
			funderName: 'National Heart Lung and Blood Institute'
		},
    {
			funderGridID: 'grid.280285.5',
			funderName: 'United States National Library of Medicine'
		}, {
			funderGridID: 'grid.280347.a',
			funderName: 'National Institute of Biomedical Imaging and Bioengineering'
		}, {
			funderGridID: 'grid.280655.c',
			funderName: 'National Center for Complementary and Integrative Health'
		}, {
			funderGridID: 'grid.280664.e',
			funderName: 'National Institute of Environmental Health Sciences'
		},
    {
			funderGridID: 'grid.214431.1',
			funderName: 'National Institute on Deafness and Other Communication Disorders'
		},
    // {
		// 	funderGridID: 'grid.280738.6',
		// 	funderName: 'National Institute of Nursing Research'
		// },
    {
			funderGridID: 'grid.280785.0',
			funderName: 'National Institute of General Medical Sciences'
		},
    // {
		// 	funderGridID: 'grid.281076.a',
		// 	funderName: 'National Institute on Minority Health and Health Disparities'
		// },
    {
			funderGridID: 'grid.410305.3',
			funderName: 'National Institutes of Health Clinical Center'
		}, {
			funderGridID: 'grid.416868.5',
			funderName: 'National Institute of Mental Health'
		}, {
			funderGridID: 'grid.416870.c',
			funderName: 'National Institute of Neurological Disorders and Stroke'
		}, {
			funderGridID: 'grid.419633.a',
			funderName: 'National Institute of Dental and Craniofacial Research'
		}, {
			funderGridID: 'grid.419635.c',
			funderName: 'National Institute of Diabetes and Digestive and Kidney Diseases'
		}, {
			funderGridID: 'grid.419681.3',
			funderName: 'National Institute of Allergy and Infectious Diseases'
		}, {
			funderGridID: 'grid.420085.b',
			funderName: 'National Institute on Alcohol Abuse and Alcoholism'
		}, {
			funderGridID: 'grid.420086.8',
			funderName: 'National Institute of Arthritis and Musculoskeletal and Skin Diseases'
		}, {
			funderGridID: 'grid.420089.7',
			funderName: 'Eunice Kennedy Shriver National Institute of Child Health and Human Development'
		}, {
			funderGridID: 'grid.420090.f',
			funderName: 'National Institute on Drug Abuse'
		}, {
			funderGridID: 'grid.429651.d',
			funderName: 'National Center for Advancing Translational Sciences'
		},
    // {
		// 	funderGridID: 'grid.453035.4',
		// 	funderName: 'Fogarty International Center'
		// },
    {
			funderGridID: 'grid.453125.4',
			funderName: 'Office of the Director'
		}, {
			funderGridID: 'grid.48336.3a',
			funderName: 'National Cancer Institute'
		}, {
			funderGridID: 'grid.410422.1',
			funderName: 'Center for Information Technology'
		},
    // {
		// 	funderGridID: 'grid.453876.b',
		// 	funderName: 'Center for Scientific Review'
		// }
    ]
	},
	// {
	// 	self: { funderGridID: 'grid.431093.c', funderName: 'National Science Foundation', },
	// 	childrenList: []
	// },
	// {
	// 	self: { funderGridID: 'grid.420391.d', funderName: 'United States Department of Defense', },
	// 	childrenList: []
	// }
]
export const countryFunderHierarchy: QueryViewTypes.CountryFunderHierarchy[] = [
  {
    "country": "United States",
    "totalCountryFunding": 2466075726.0,
    "gridList": [
      {
        "funderGridID": "grid.431093.c",
        "funderGridIDList": [
          "grid.440391.b",
          "grid.457927.a",
          "grid.457885.3",
          "grid.457921.c",
          "grid.457839.4",
          "grid.457898.f",
          "grid.457805.b",
          "grid.457922.f",
          "grid.517217.7",
          "grid.510765.0",
          "grid.467634.4",
          "grid.457892.5",
          "grid.467644.3",
          "grid.457875.c",
          "grid.440541.0",
          "grid.457911.f",
          "grid.457794.c",
          "grid.457888.e",
          "grid.457785.c",
          "grid.473792.c",
          "grid.457770.6",
          "grid.457904.b",
          "grid.510752.4",
          "grid.457893.4",
          "grid.457758.c",
          "grid.457842.8",
          "grid.467627.6",
          "grid.467631.1",
          "grid.457896.1",
          "grid.510764.1",
          "grid.457829.5",
          "grid.516359.d",
          "grid.457762.5",
          "grid.468484.2",
          "grid.457891.6",
          "grid.457803.d",
          "grid.467626.7",
          "grid.457900.f",
          "grid.457797.f",
          "grid.457846.c",
          "grid.457779.f",
          "grid.248193.5",
          "grid.457878.1",
          "grid.457907.8",
          "grid.457773.5",
          "grid.457768.f",
          "grid.457813.c",
          "grid.467624.5",
          "grid.457802.c",
          "grid.457799.1",
          "grid.457793.b",
          "grid.457789.0",
          "grid.457814.b",
          "grid.457801.f",
          "grid.457920.d",
          "grid.457832.f",
          "grid.517218.8",
          "grid.457821.d",
          "grid.457783.a",
          "grid.457916.8",
          "grid.457924.9",
          "grid.515271.5",
          "grid.467629.8",
          "grid.457818.7",
          "grid.503039.c",
          "grid.440290.b",
          "grid.457772.4",
          "grid.467630.0",
          "grid.457836.b",
          "grid.457810.f",
          "grid.457845.f"
        ],
        "funderName": "National Science Foundation",
        "fundingUSDSum": 1
      },
      {
        "funderGridID": "grid.94365.3d",
        "funderGridIDList": [
          "grid.419475.a",
          "grid.214431.1",
          "grid.279885.9",
          "grid.280030.9",
          "grid.280128.1",
          "grid.280285.5",
          "grid.280347.a",
          "grid.280655.c",
          "grid.280664.e",
          "grid.280738.6",
          "grid.280785.0",
          "grid.281076.a",
          "grid.410305.3",
          "grid.416868.5",
          "grid.416870.c",
          "grid.419633.a",
          "grid.419635.c",
          "grid.419681.3",
          "grid.420085.b",
          "grid.420086.8",
          "grid.420089.7",
          "grid.420090.f",
          "grid.429651.d",
          "grid.453035.4",
          "grid.453125.4",
          "grid.48336.3a",
          "grid.410422.1",
          "grid.453876.b"
        ],
        "funderName": "National Institutes of Health",
        "fundingUSDSum": 1
      },
      {
        "funderGridID": "grid.3532.7",
        "funderName": "National Oceanic and Atmospheric Administration",
        "fundingUSDSum": 112831146.0
      },
      {
        "funderGridID": "grid.453070.5",
        "funderName": "Office of Advanced Scientific Computing Research",
        "fundingUSDSum": 22183039.0
      },
      {
        "funderGridID": "grid.420434.5",
        "funderName": "United States Department of the Navy",
        "fundingUSDSum": 16168297.0
      },
      {
        "funderGridID": "grid.419881.d",
        "funderName": "United States Department of Education",
        "fundingUSDSum": 14060515.0
      },
      {
        "funderGridID": "grid.427904.c",
        "funderName": "United States Department of the Army",
        "fundingUSDSum": 6602361.0
      }
    ]
  },
  {
    "country": "United Kingdom",
    "totalCountryFunding": 829404954.0,
    "gridList": [
      {
        "funderGridID": "grid.421091.f",
        "funderName": "Engineering and Physical Sciences Research Council",
        "fundingUSDSum": 739169251.0
      },
      {
        "funderGridID": "grid.14105.31",
        "funderName": "Medical Research Council",
        "fundingUSDSum": 31892757.0
      },
      {
        "funderGridID": "grid.426413.6",
        "funderName": "Arts and Humanities Research Council",
        "fundingUSDSum": 22147479.0
      },
      {
        "funderGridID": "grid.434257.3",
        "funderName": "Economic and Social Research Council",
        "fundingUSDSum": 21571453.0
      }
    ]
  },
  {
    "country": "Japan",
    "totalCountryFunding": 248211148.0,
    "gridList": [
      {
        "funderGridID": "grid.54432.34",
        "funderName": "Japan Society for the Promotion of Science",
        "fundingUSDSum": 231197049.0
      },
      {
        "funderGridID": "grid.415828.2",
        "funderName": "Ministry of Health Labour and Welfare",
        "fundingUSDSum": 16652879.0
      }
    ]
  },
  {
    "country": "Canada",
    "totalCountryFunding": 203443391.0,
    "gridList": [
      {
        "funderGridID": "grid.452912.9",
        "funderName": "Natural Sciences and Engineering Research Council",
        "fundingUSDSum": 139404561.0
      },
      {
        "funderGridID": "grid.248883.d",
        "funderName": "Canadian Institutes of Health Research",
        "fundingUSDSum": 26588067.0
      },
      {
        "funderGridID": "grid.183804.6",
        "funderName": "Social Sciences and Humanities Research Council",
        "fundingUSDSum": 23124748.0
      },
      {
        "funderGridID": "grid.439998.6",
        "funderName": "Canada Foundation for Innovation",
        "fundingUSDSum": 7424561.0
      }
    ]
  },
  {
    "country": "Belgium",
    "totalCountryFunding": 123785961.0,
    "gridList": [
      {
        "funderGridID": "grid.452896.4",
        "funderName": "European Research Council",
        "fundingUSDSum": 123785961.0
      }
    ]
  },
  {
    "country": "Switzerland",
    "totalCountryFunding": 77987183.0,
    "gridList": [
      {
        "funderGridID": "grid.425888.b",
        "funderName": "Swiss National Science Foundation",
        "fundingUSDSum": 77317044.0
      }
    ]
  },
  {
    "country": "China",
    "totalCountryFunding": 73389062.0,
    "gridList": [
      {
        "funderGridID": "grid.419696.5",
        "funderName": "National Natural Science Foundation of China",
        "fundingUSDSum": 57752242.0
      },
      {
        "funderGridID": "grid.453115.7",
        "funderName": "Innovation and Technology Commission",
        "fundingUSDSum": 14125751.0
      }
    ]
  },
  {
    "country": "Australia",
    "totalCountryFunding": 30969119.0,
    "gridList": [
      {
        "funderGridID": "grid.413452.5",
        "funderName": "Australian Research Council",
        "fundingUSDSum": 30526711.0
      }
    ]
  },
  {
    "country": "Ireland",
    "totalCountryFunding": 25226370.0,
    "gridList": [
      {
        "funderGridID": "grid.437854.9",
        "funderName": "Science Foundation Ireland",
        "fundingUSDSum": 25226370.0
      }
    ]
  },
  {
    "country": "Sweden",
    "totalCountryFunding": 51096064.0,
    "gridList": [
      {
        "funderGridID": "grid.208387.6",
        "funderName": "Swedish Research Council",
        "fundingUSDSum": 19336868.0
      },
      {
        "funderGridID": "grid.452997.4",
        "funderName": "Swedish Foundation for Strategic Research",
        "fundingUSDSum": 15361868.0
      },
      {
        "funderGridID": "grid.453022.2",
        "funderName": "VINNOVA",
        "fundingUSDSum": 12425385.0
      }
    ]
  },
  {
    "country": "Finland",
    "totalCountryFunding": 15880562.0,
    "gridList": [
      {
        "funderGridID": "grid.15098.35",
        "funderName": "Academy of Finland",
        "fundingUSDSum": 15880562.0
      }
    ]
  },
  {
    "country": "Austria",
    "totalCountryFunding": 21143604.0,
    "gridList": [
      {
        "funderGridID": "grid.25111.36",
        "funderName": "FWF Austrian Science Fund",
        "fundingUSDSum": 13382000.0
      },
      {
        "funderGridID": "grid.426375.1",
        "funderName": "Vienna Science and Technology Fund",
        "fundingUSDSum": 7761604.0
      }
    ]
  },
  {
    "country": "Israel",
    "totalCountryFunding": 13256298.0,
    "gridList": [
      {
        "funderGridID": "grid.425339.a",
        "funderName": "Israel Science Foundation",
        "fundingUSDSum": 11522585.0
      }
    ]
  },
  {
    "country": "France",
    "totalCountryFunding": 10149927.0,
    "gridList": [
      {
        "funderGridID": "grid.22058.3d",
        "funderName": "Agence Nationale de la Recherche",
        "fundingUSDSum": 10149927.0
      }
    ]
  },
  {
    "country": "Portugal",
    "totalCountryFunding": 7756259.0,
    "gridList": [
      {
        "funderGridID": "grid.22919.31",
        "funderName": "Fundação para a Ciência e Tecnologia",
        "fundingUSDSum": 7756259.0
      }
    ]
  }
]

export const queryViewData = {
	startYearRange: [2000, 2021],
	endYearRange: [2000, 2030],
	fundingUSDRange: [0, 4000000000],
	countryList: [
    'United States',
    // 'United Kingdom', 'China'
  ],
	funderOrganizationHierarchy: funderOrganizationHierarchy,
}

// --- GrantView ---
// --- PIView ---
// --- MainView ---
// --- ImpactStatisticsView ---
// --- ImpactEntityView ---
// export const impactEntityViewData = {
//   entityLevelDict: {
// 	"paper": "L2",
// 	"patent": 'L2',
// 	"clinical_trial": 'L1',
// 	"policy": isSampleData ? 'L1' : 'L3', // online demo: 'L1', paper-case1: 'L3'
// 	"newsfeed": 'L1',
//   },
// }

// ===== caseType: "case1" (end) =====


// ===== field code to name (start) =====
export const paperFieldCode2Name: { [paperFieldCode: string]: string } = paperFieldCode2NameJson as { [paperFieldCode: string]: string }
// export const paperFieldCode2Name: { [paperFieldCode: string]: string } = paperFieldCode2NameJson
export const meshCode2Name: { [meshCode: string]: string } = meshCode2NameJson
export const cpcCode2Name: { [cpcCode: string]: string } = {
  // cpc section
  'A': 'Human Necessities',
  'B': 'Performing Operations; Transporting',
  'C': 'Chemistry; Metallurgy',
  'D': 'Textiles; Paper',
  'E': 'Fixed Constructions',
  'F': 'Mechanical Engineering; Lighting; Heating; Weapons; Blasting',
  'G': 'Physics',
  'H': 'Electricity',
  'Y': 'General Tagging Of New Technological Developments; General Tagging Of Cross-sectional Technologies Spanning Over Several Sections Of The Ipc; Technical Subjects Covered By Former Uspc Cross-reference Art Collections [xracs] And Digests',

  // cpc subsection
	'A01': 'Agriculture; Forestry; Animal Husbandry; Hunting; Trapping; Fishing',
	'A21': 'Baking; Edible Doughs',
	'A22': 'Butchering; Meat Treatment; Processing Poultry Or Fish',
	'A23': 'Foods Or Foodstuffs; Treatment Thereof, Not Covered By Other Classes',
	'A24': "Tobacco; Cigars; Cigarettes; Simulated Smoking Devices; Smokers' Requisites",
	'A41': 'Wearing Apparel',
	'A42': 'Headwear',
	'A43': 'Footwear',
	'A44': 'Haberdashery; Jewellery',
	'A45': 'Hand Or Travelling Articles',
	'A46': 'Brushware',
	'A47': 'Furniture; Domestic Articles Or Appliances; Coffee Mills; Spice Mills; Suction Cleaners In General',
	'A61': 'Medical Or Veterinary Science; Hygiene',
	'A62': 'Life-Saving; Fire-Fighting',
	'A63': 'Sports; Games; Amusements',
	'A99': 'Subject Matter Not Otherwise Provided For In This Section',
	'B01': 'Physical Or Chemical Processes Or Apparatus In General',
	'B02': 'Crushing, Pulverising, Or Disintegrating; Preparatory Treatment Of Grain For Milling',
	'B03': 'Separation Of Solid Materials Using Liquids Or Using Pneumatic Tables Or Jigs; Magnetic Or Electrostatic Separation Of Solid Materials From Solid Materials Or Fluids; Separation By High-Voltage Electric Fields',
	'B04': 'Centrifugal Apparatus Or Machines For Carrying-Out Physical Or Chemical Processes',
	'B05': 'Spraying Or Atomising In General; Applying Fluent Materials To Surfaces, In General',
	'B06': 'Generating Or Transmitting Mechanical Vibrations In General',
	'B07': 'Separating Solids From Solids; Sorting',
	'B08': 'Cleaning',
	'B09': 'Disposal Of Solid Waste; Reclamation Of Contaminated Soil',
	'B21': 'Mechanical Metal-Working Without Essentially Removing Material; Punching Metal',
	'B22': 'Casting; Powder Metallurgy',
	'B23': 'Machine Tools; Metal-Working Not Otherwise Provided For',
	'B24': 'Grinding; Polishing',
	'B25': 'Hand Tools; Portable Power-Driven Tools; Manipulators',
	'B26': 'Hand Cutting Tools; Cutting; Severing',
	'B27': 'Working Or Preserving Wood Or Similar Material; Nailing Or Stapling Machines In General',
	'B28': 'Working Cement, Clay, Or Stone',
	'B29': 'Working Of Plastics; Working Of Substances In A Plastic State In General',
	'B30': 'Presses',
	'B31': 'Making Articles Of Paper, Cardboard Or Material Worked In A Manner Analogous To Paper; Working Paper, Cardboard Or Material Worked In A Manner Analogous To Paper',
	'B32': 'Layered Products',
	'B33': 'Additive Manufacturing Technology',
	'B41': 'Printing; Lining Machines; Typewriters; Stamps',
	'B42': 'Bookbinding; Albums; Files; Special Printed Matter',
	'B43': 'Writing Or Drawing Implements; Bureau Accessories',
	'B44': 'Decorative Arts',
	'B60': 'Vehicles In General',
	'B61': 'Railways',
	'B62': 'Land Vehicles For Travelling Otherwise Than On Rails',
	'B63': 'Ships Or Other Waterborne Vessels; Related Equipment',
	'B64': 'Aircraft; Aviation; Cosmonautics',
	'B65': 'Conveying; Packing; Storing; Handling Thin Or Filamentary Material',
	'B66': 'Hoisting; Lifting; Hauling',
	'B67': 'Opening, Closing ; Or Cleaning;  Bottles, Jars Or Similar Containers; Liquid Handling',
	'B68': 'Saddlery; Upholstery',
	'B81': 'Microstructural Technology',
	'B82': 'Nanotechnology',
	'B99': 'Subject Matter Not Otherwise Provided For In This Section',
	'C01': 'Inorganic Chemistry',
	'C02': 'Treatment Of Water, Waste Water, Sewage, Or Sludge',
	'C03': 'Glass; Mineral Or Slag Wool',
	'C04': 'Cements; Concrete; Artificial Stone; Ceramics; Refractories',
	'C05': 'Fertilisers; Manufacture Thereof',
	'C06': 'Explosives; Matches',
	'C07': 'Organic Chemistry',
	'C08': 'Organic Macromolecular Compounds; Their Preparation Or Chemical Working-Up; Compositions Based Thereon',
	'C09': 'Dyes; Paints; Polishes; Natural Resins; Adhesives; Compositions Not Otherwise Provided For; Applications Of Materials Not Otherwise Provided For',
	'C10': 'Petroleum, Gas Or Coke Industries; Technical Gases Containing Carbon Monoxide; Fuels; Lubricants; Peat',
	'C11': 'Animal Or Vegetable Oils, Fats, Fatty Substances Or Waxes; Fatty Acids Therefrom; Detergents; Candles',
	'C12': 'Biochemistry; Beer; Spirits; Wine; Vinegar; Microbiology; Enzymology; Mutation Or Genetic Engineering',
	'C13': 'Sugar Industry',
	'C14': 'Skins; Hides; Pelts; Leather',
	'C21': 'Metallurgy Of Iron',
	'C22': 'Metallurgy; Ferrous Or Non-Ferrous Alloys; Treatment Of Alloys Or Non-Ferrous Metals',
	'C23': 'Coating Metallic Material; Coating Material With Metallic Material; Chemical Surface Treatment; Diffusion Treatment Of Metallic Material; Coating By Vacuum Evaporation, By Sputtering, By Ion Implantation Or By Chemical Vapour Deposition, In General; Inhibiting Corrosion Of Metallic Material Or Incrustation In General',
	'C25': 'Electrolytic Or Electrophoretic Processes; Apparatus Therefor',
	'C30': 'Crystal Growth',
	'C40': 'Combinatorial Technology',
	'C99': 'Subject Matter Not Otherwise Provided For In This Section',
	'D01': 'Natural Or Man-Made Threads Or Fibres; Spinning',
	'D02': 'Yarns; Mechanical Finishing Of Yarns Or Ropes; Warping Or Beaming',
	'D03': 'Weaving',
	'D04': 'Braiding; Lace-Making; Knitting; Trimmings; Non-Woven Fabrics',
	'D05': 'Sewing; Embroidering; Tufting',
	'D06': 'Treatment Of Textiles Or The Like; Laundering; Flexible Materials Not Otherwise Provided For',
	'D07': 'Ropes; Cables Other Than Electric',
	'D10': 'Indexing Scheme Associated With Sublasses Of Section D, Relating To Textiles',
	'D21': 'Paper-Making; Production Of Cellulose',
	'D99': 'Subject Matter Not Otherwise Provided For In This Section',
	'E01': 'Construction Of Roads, Railways, Or Bridges',
	'E02': 'Hydraulic Engineering; Foundations; Soil Shifting',
	'E03': 'Water Supply; Sewerage',
	'E04': 'Building',
	'E05': 'Locks; Keys; Window Or Door Fittings; Safes',
	'E06': 'Doors, Windows, Shutters, Or Roller Blinds In General; Ladders',
	'E21': 'Earth Drilling; Mining',
	'E99': 'Subject Matter Not Otherwise Provided For In This Section',
	'F01': 'Machines Or Engines In General; Engine Plants In General; Steam Engines',
	'F02': 'Combustion Engines; Hot-Gas Or Combustion-Product Engine Plants',
	'F03': 'Machines Or Engines For Liquids; Wind, Spring, Or Weight Motors; Producing Mechanical Power Or A Reactive Propulsive Thrust, Not Otherwise Provided For',
	'F04': 'Positive - Displacement Machines For Liquids; Pumps For Liquids Or Elastic Fluids',
	'F05': 'Indexing Schemes Relating To Engines Or Pumps In Various Subclasses Of Classes F01-F04',
	'F15': 'Fluid-Pressure Actuators; Hydraulics Or Pneumatics In General',
	'F16': 'Engineering Elements And Units; General Measures For Producing And Maintaining Effective Functioning Of Machines Or Installations; Thermal Insulation In General',
	'F17': 'Storing Or Distributing Gases Or Liquids',
	'F21': 'Lighting',
	'F22': 'Steam Generation',
	'F23': 'Combustion Apparatus; Combustion Processes',
	'F24': 'Heating; Ranges; Ventilating',
	'F25': 'Refrigeration Or Cooling; Combined Heating And Refrigeration Systems; Heat Pump Systems; Manufacture Or Storage Of Ice; Liquefaction Solidification Of Gases',
	'F26': 'Drying',
	'F27': 'Furnaces; Kilns; Ovens; Retorts',
	'F28': 'Heat Exchange In General',
	'F41': 'Weapons',
	'F42': 'Ammunition; Blasting',
	'F99': 'Subject Matter Not Otherwise Provided For In This Section',
	'G01': 'Measuring; Testing',
	'G02': 'Optics',
	'G03': 'Photography; Cinematography; Analogous Techniques Using Waves Other Than Optical Waves; Electrography; Holography',
	'G04': 'Horology',
	'G05': 'Controlling; Regulating',
	'G06': 'Computing; Calculating; Counting',
	'G07': 'Checking-Devices',
	'G08': 'Signalling',
	'G09': 'Education; Cryptography; Display; Advertising; Seals',
	'G10': 'Musical Instruments; Acoustics',
	'G11': 'Information Storage',
	'G12': 'Instrument Details',
	'G16': 'Information And Communication Technology [Ict] Specially Adapted For Specific Application Fields',
	'G21': 'Nuclear Physics; Nuclear Engineering',
	'G99': 'Subject Matter Not Otherwise Provided For In This Section',
	'H01': 'Basic Electric Elements',
	'H02': 'Generation; Conversion Or Distribution Of Electric Power',
	'H03': 'Basic Electronic Circuitry',
	'H04': 'Electric Communication Technique',
	'H05': 'Electric Techniques Not Otherwise Provided For',
	'H99': 'Subject Matter Not Otherwise Provided For In This Section',
	'Y02': 'Technologies Or Applications For Mitigation Or Adaptation Against Climate Change',
	'Y04': 'Information Or Communication Technologies Having An Impact On Other Technology Areas',
	'Y10': 'Technical Subjects Covered By Former Uspc',

  // cpc group
  "A01B": "Soil Working In Agriculture Or Forestry; Parts, Details, Or Accessories Of Agricultural Machines Or Implements, In General ",
	"A01C": "Planting; Sowing; Fertilising ",
	"A01D": "Harvesting; Mowing",
	"A01F": "Processing Of Harvested Produce; Hay Or Straw Presses; Devices For Storing Agricultural Or Horticultural Produce ",
	"A01G": "Horticulture; Cultivation Of Vegetables, Flowers, Rice, Fruit, Vines, Hops Or Seaweed; Forestry; Watering ",
	"A01H": "New Plants Or ; Non-Transgenic;  Processes For Obtaining Them; Plant Reproduction By Tissue Culture Techniques",
	"A01J": "Manufacture Of Dairy Products ",
	"A01K": "Animal Husbandry; Care Of Birds, Fishes, Insects; Fishing; Rearing Or Breeding Animals, Not Otherwise Provided For; New Breeds Of Animals",
	"A01L": "Shoeing Of Animals",
	"A01M": "Catching, Trapping Or Scaring Of Animals ; Apparatus For The Destruction Of Noxious Animals Or Noxious Plants",
	"A01N": "Preservation Of Bodies Of Humans Or Animals Or Plants Or Parts Thereof ; Biocides, E.G. As Disinfectants, As Pesticides Or As Herbicides ; Pest Repellants Or Attractants; Plant Growth Regulators",
	"A01P": "Biocidal, Pest Repellant, Pest Attractant Or Plant Growth Regulatory Activity Of Chemical Compounds Or Preparations",
	"A21B": "Bakers' Ovens; Machines Or Equipment For Baking ",
	"A21C": "Machines Or Equipment For Making Or Processing Doughs; Handling Baked Articles Made From Dough",
	"A21D": "Treatment, E.G. Preservation, Of Flour Or Dough, E.G. By Addition Of Materials; Baking; Bakery Products; Preservation Thereof",
	"A22B": "Slaughtering",
	"A22C": "Processing Meat, Poultry, Or Fish ",
	"A23B": "Preserving, E.G. By Canning, Meat, Fish, Eggs, Fruit, Vegetables, Edible Seeds; Chemical Ripening Of Fruit Or Vegetables; The Preserved, Ripened, Or Canned Products",
	"A23C": "Dairy Products, E.G. Milk, Butter Or Cheese; Milk Or Cheese Substitutes; Making Thereof ",
	"A23D": "Edible Oils Or Fats, E.G. Margarines, Shortenings, Cooking Oils ",
	"A23F": "Coffee; Tea; Their Substitutes; Manufacture, Preparation, Or Infusion Thereof",
	"A23G": "Cocoa; Cocoa Products, E.G. Chocolate; Substitutes For Cocoa Or Cocoa Products; Confectionery; Chewing Gum; Ice-Cream; Preparation Thereof",
	"A23J": "Protein Compositions For Foodstuffs; Working-Up Proteins For Foodstuffs; Phosphatide Compositions For Foodstuffs",
	"A23K": "Fodder",
	"A23L": "Foods, Foodstuffs, Or Non-Alcoholic Beverages, Not Covered By Subclasses A21D Or A23B-A23J; Their Preparation Or Treatment, E.G. Cooking, Modification Of Nutritive Qualities, Physical Treatment ; Preservation Of Foods Or Foodstuffs, In General",
	"A23N": "Machines Or Apparatus For Treating Harvested Fruit, Vegetables Or Flower Bulbs In Bulk, Not Otherwise Provided For; Peeling Vegetables Or Fruit In Bulk; Apparatus For Preparing Animal Feeding- Stuffs ",
	"A23P": "Shaping Or Working Of Foodstuffs, Not Fully Covered By A Single Other Subclass",
	"A23V": "Indexing Scheme Relating To Foods, Foodstuffs Or Non-Alcoholic Beverages",
	"A23Y": "Indexing Scheme Relating To Lactic Or Propionic Acid Bacteria Used In Foodstuffs Or Food Preparation",
	"A24B": "Manufacture Or Preparation Of Tobacco For Smoking Or Chewing; Tobacco; Snuff",
	"A24C": "Machines For Making Cigars Or Cigarettes",
	"A24D": "Cigars; Cigarettes; Tobacco Smoke Filters; Mouthpieces For Cigars Or Cigarettes; Manufacture Of Tobacco Smoke Filters Or Mouthpieces",
	"A24F": "Smokers' Requisites; Match Boxes; Simulated Smoking Devices ",
	"A41B": "Shirts; Underwear; Baby Linen; Handkerchiefs",
	"A41C": "Corsets; Brassieres",
	"A41D": "Outerwear; Protective Garments; Accessories",
	"A41F": "Garment Fastenings; Suspenders",
	"A41G": "Artificial Flowers; Wigs; Masks; Feathers",
	"A41H": "Appliances Or Methods For Making Clothes, E.G. For Dress-Making, For Tailoring, Not Otherwise Provided For ",
	"A42B": "Hats; Head Coverings ",
	"A42C": "Manufacturing Or Trimming Head Coverings, E.G. Hats",
	"A43B": "Characteristic Features Of Footwear; Parts Of Footwear",
	"A43C": "Fastenings Or Attachments Of Footwear; Laces In General",
	"A43D": "Machines, Tools, Equipment Or Methods For Manufacturing Or Repairing Footwear",
	"A44B": "Buttons, Pins, Buckles, Slide Fasteners, Or The Like ",
	"A44C": "Personal Adornments, E.G. Jewellery; Coins",
	"A44D": "Indexing Scheme Relating To Buttons, Pins, Buckles Or Slide Fasteners, And To Jewellery, Bracelets Or Other Personal Adornments",
	"A45B": "Walking Sticks ; Umbrellas; Ladies' Or Like Fans ",
	"A45C": "Purses; Luggage; Hand Carried Bags",
	"A45D": "Hairdressing Or Shaving Equipment ; Equipment For Cosmetics Or Cosmetic Treatments, E.G. For Manicuring Or Pedicuring",
	"A45F": "Travelling Or Camp Equipment: Sacks Or Packs Carried On The Body",
	"A46B": "Brushes ",
	"A46D": "Manufacture Of Brushes",
	"A47B": "Tables; Desks; Office Furniture; Cabinets; Drawers; General Details Of Furniture ",
	"A47C": "Chairs ; Sofas; Beds ",
	"A47D": "Furniture Specially Adapted For Children ",
	"A47F": "Special Furniture, Fittings, Or Accessories For Shops, Storehouses, Bars, Restaurants Or The Like; Paying Counters",
	"A47G": "Household Or Table Equipment ",
	"A47H": "Furnishings For Windows Or Doors ",
	"A47J": "Kitchen Equipment; Coffee Mills; Spice Mills; Apparatus For Making Beverages",
	"A47K": "Sanitary Equipment Not Otherwise Provided For ; Toilet Accessories ",
	"A47L": "Domestic Washing Or Cleaning ; Suction Cleaners In General ",
	"A61B": "Diagnosis; Surgery; Identification ",
	"A61C": "Dentistry; Apparatus Or Methods For Oral Or Dental Hygiene ",
	"A61D": "Veterinary Instruments, Implements, Tools, Or Methods",
	"A61F": "Filters Implantable Into Blood Vessels; Prostheses; Devices Providing Patency To, Or Preventing Collapsing Of, Tubular Structures Of The Body, E.G. Stents; Orthopaedic, Nursing Or Contraceptive Devices; Fomentation; Treatment Or Protection Of Eyes Or Ears; Bandages, Dressings Or Absorbent Pads; First-Aid Kits ",
	"A61G": "Transport, Personal Conveyances, Or Accommodation Specially Adapted For Patients Or Disabled Persons ; Operating Tables Or Chairs; Chairs For Dentistry; Funeral Devices ",
	"A61H": "Physical Therapy Apparatus, E.G. Devices For Locating Or Stimulating Reflex Points In The Body; Artificial Respiration; Massage; Bathing Devices For Special Therapeutic Or Hygienic Purposes Or Specific Parts Of The Body ",
	"A61J": "Containers Specially Adapted For Medical Or Pharmaceutical Purposes; Devices Or Methods Specially Adapted For Bringing Pharmaceutical Products Into Particular Physical Or Administering Forms; Devices For Administering Food Or Medicines Orally; Baby Comforters; Devices For Receiving Spittle",
	"A61K": "Preparations For Medical, Dental, Or Toilet Purposes ",
	"A61L": "Methods Or Apparatus For Sterilising Materials Or Objects In General; Disinfection, Sterilisation, Or Deodorisation Of Air; Chemical Aspects Of Bandages, Dressings, Absorbent Pads, Or Surgical Articles; Materials For Bandages, Dressings, Absorbent Pads, Or Surgical Articles ",
	"A61M": "Devices For Introducing Media Into, Or Onto, The Body ; Devices For Transducing Body Media Or For Taking Media From The Body ; Devices For Producing Or Ending Sleep Or Stupor ",
	"A61N": "Electrotherapy; Magnetotherapy; Radiation Therapy; Ultrasound Therapy ",
	"A61P": "Specific Therapeutic Activity Of Chemical Compounds Or Medicinal Preparations",
	"A61Q": "Specific Use Of Cosmetics Or Similar Toilet Preparations",
	"A62B": "Devices, Apparatus Or Methods For Life-Saving ",
	"A62C": "Fire-Fighting ",
	"A62D": "Chemical Means For Extinguishing Fires Or For Combating Or Protecting Against Harmful Chemical Agents; Chemical Materials For Use In Breathing Apparatus",
	"A63B": "Apparatus For Physical Training, Gymnastics, Swimming, Climbing, Or Fencing; Ball Games; Training Equipment ",
	"A63C": "Skates; Skis; Roller Skates; Design Or Layout Of Courts, Rinks Or The Like ",
	"A63D": "Bowling Games, E.G. Skittles, Bocce Or Bowls; Installations Therefor; Bagatelle Or Similar Games; Billiards ",
	"A63F": "Card, Board, Or Roulette Games; Indoor Games Using Small Moving Playing Bodies; Video Games; Games Not Otherwise Provided For",
	"A63G": "Merry-Go-Rounds; Swings; Rocking-Horses; Chutes; Switchbacks; Similar Devices For Public Amusement",
	"A63H": "Toys, E.G. Tops, Dolls, Hoops Or Building Blocks",
	"A63J": "Devices For Theatres, Circuses, Or The Like; Conjuring Appliances Or The Like",
	"A63K": "Racing; Riding Sports; Equipment Or Accessories Therefor ",
	"A99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"B01B": "Boiling; Boiling Apparatus ; ; Evaporation; Evaporation Apparatus",
	"B01D": "Separation ",
	"B01F": "Mixing, E.G. Dissolving, Emulsifying Or Dispersing ",
	"B01J": "Chemical Or Physical Processes, E.G. Catalysis Or Colloid Chemistry; Their Relevant Apparatus",
	"B01L": "Chemical Or Physical Laboratory Apparatus For General Use ",
	"B02B": "Preparing Grain For Milling; Refining Granular Fruit To Commercial Products By Working The Surface ",
	"B02C": "Crushing, Pulverising, Or Disintegrating In General; Milling Grain ",
	"B03B": "Separating Solid Materials Using Liquids Or Using Pneumatic Tables Or Jigs ",
	"B03C": "Magnetic Or Electrostatic Separation Of Solid Materials From Solid Materials Or Fluids; Separation By High-Voltage Electric Fields ",
	"B03D": "Flotation; Differential Sedimentation ",
	"B04B": "Centrifuges ",
	"B04C": "Apparatus Using Free Vortex Flow, E.G. Cyclones ",
	"B05B": "Spraying Apparatus; Atomising Apparatus; Nozzles ",
	"B05C": "Apparatus For Applying Fluent Materials To Surfaces, In General ",
	"B05D": "Processes For Applying Fluent Materials To Surfaces, In General ",
	"B06B": "Methods Or Apparatus For Generating Or Transmitting Mechanical Vibrations Of Infrasonic, Sonic, Or Ultrasonic Frequency, ; E.G.;  For Performing Mechanical Work In General ",
	"B07B": "Separating Solids From Solids By Sieving, Screening, Sifting Or By Using Gas Currents; Separating By Other Dry Methods Applicable To Bulk Material, E.G. Loose Articles Fit To Be Handled Like Bulk Material ",
	"B07C": "Postal Sorting; Sorting Individual Articles, Or Bulk Material Fit To Be Sorted Piece-Meal, E.G. By Picking ",
	"B08B": "Cleaning In General; Prevention Of Fouling In General ",
	"B09B": "Disposal Of Solid Waste",
	"B09C": "Reclamation Of Contaminated Soil ",
	"B21B": "Rolling Of Metal ",
	"B21C": "Manufacture Of Metal Sheets, Wire, Rods, Tubes Or Profiles, Otherwise Than By Rolling; Auxiliary Operations Used In Connection With Metal-Working Without Essentially Removing Material",
	"B21D": "Working Or Processing Of Sheet Metal Or Metal Tubes, Rods Or Profiles Without Essentially Removing Material; Punching Metal ",
	"B21F": "Working Or Processing Of Metal Wire ",
	"B21G": "Making Needles, Pins Or Nails Of Metal",
	"B21H": "Making Particular Metal Objects By Rolling, E.G. Screws, Wheels, Rings, Barrels, Balls ",
	"B21J": "Forging; Hammering; Pressing Metal; Riveting; Forge Furnaces ",
	"B21K": "Making Forged Or Pressed Metal Products, E.G. Horse-Shoes, Rivets, Bolts Or Wheels ",
	"B21L": "Making Metal Chains ",
	"B22C": "Foundry Moulding ",
	"B22D": "Casting Of Metals; Casting Of Other Substances By The Same Processes Or Devices ",
	"B22F": "Working Metallic Powder; Manufacture Of Articles From Metallic Powder; Making Metallic Powder ; Apparatus Or Devices Specially Adapted For Metallic Powder",
	"B23B": "Turning; Boring ",
	"B23C": "Milling ",
	"B23D": "Planing; Slotting; Shearing; Broaching; Sawing; Filing; Scraping; Like Operations For Working Metal By Removing Material, Not Otherwise Provided For ",
	"B23F": "Making Gears Or Toothed Racks ",
	"B23G": "Thread Cutting; Working Of Screws, Bolt Heads, Or Nuts, In Conjunction Therewith ",
	"B23H": "Working Of Metal By The Action Of A High Concentration Of Electric Current On A Workpiece Using An Electrode Which Takes The Place Of A Tool; Such Working Combined With Other Forms Of Working Of Metal ",
	"B23K": "Soldering Or Unsoldering; Welding; Cladding Or Plating By Soldering Or Welding; Cutting By Applying Heat Locally, E.G. Flame Cutting; Working By Laser Beam ",
	"B23P": "Metal-Working Not Otherwise Provided For; Combined Operations; Universal Machine Tools ",
	"B23Q": "Details, Components, Or Accessories For Machine Tools, E.G. Arrangements For Copying Or Controlling ; Machine Tools In General Characterised By The Construction Of Particular Details Or Components; Combinations Or Associations Of Metal-Working Machines, Not Directed To A Particular Result",
	"B24B": "Machines, Devices, Or Processes For Grinding Or Polishing ; Dressing Or Conditioning Of Abrading Surfaces; Feeding Of Grinding, Polishing, Or Lapping Agents",
	"B24C": "Abrasive Or Related Blasting With Particulate Material",
	"B24D": "Tools For Grinding, Buffing Or Sharpening ",
	"B25B": "Tools Or Bench Devices Not Otherwise Provided For, For Fastening, Connecting, Disengaging Or Holding",
	"B25C": "Hand-Held Nailing Or Stapling Tools; Manually Operated Portable Stapling Tools ",
	"B25D": "Percussive Tools ",
	"B25F": "Combination Or Multi-Purpose Tools Not Otherwise Provided For; Details Or Components Of Portable Power-Driven Tools Not Particularly Related To The Operations Performed And Not Otherwise Provided For ",
	"B25G": "Handles For Hand Implements ",
	"B25H": "Workshop Equipment, E.G. For Marking-Out Work; Storage Means For Workshops ",
	"B25J": "Manipulators; Chambers Provided With Manipulation Devices ",
	"B26B": "Hand-Held Cutting Tools Not Otherwise Provided For ",
	"B26D": "Cutting; Details Common To Machines For Perforating, Punching, Cutting-Out, Stamping-Out Or Severing ",
	"B26F": "Perforating; Punching; Cutting-Out; Stamping-Out; Severing By Means Other Than Cutting ",
	"B27B": "Saws For Wood Or Similar Material; Components Or Accessories Therefor ",
	"B27C": "Planing, Drilling, Milling, Turning Or Universal Machines For Wood Or Similar Material ",
	"B27D": "Working Veneer Or Plywood ",
	"B27F": "Dovetailed Work; Tenons; Slotting Machines For Wood Or Similar Material; Nailing Or Stapling Machines ",
	"B27G": "Accessory Machines Or Apparatus For Working Wood Or Similar Materials; Tools For Working Wood Or Similar Materials ; Safety Devices For Wood Working Machines Or Tools",
	"B27H": "Bending Wood Or Similar Material; Cooperage; Making Wheels From Wood Or Similar Material",
	"B27J": "Mechanical Working Of Cane, Cork, Or Similar Materials",
	"B27K": "Processes, Apparatus Or Selection Of Substances For Impregnating, Staining, Dyeing, Bleaching Of Wood Or Similar Materials, Or Treating Of Wood Or Similar Materials With Permeant Liquids, Not Otherwise Provided For ; Chemical Or Physical Treatment Of Cork, Cane, Reed, Straw Or Similar Materials",
	"B27L": "Removing Bark Or Vestiges Of Branches ; Splitting Wood; Manufacture Of Veneer, Wooden Sticks, Wood Shavings, Wood Fibres Or Wood Powder",
	"B27M": "Working Of Wood Not Provided For In Subclasses B27B\u00a0-\u00a0B27L; Manufacture Of Specific Wooden Articles",
	"B27N": "Manufacture By Dry Processes Of Articles, With Or Without Organic Binding Agents, Made From Particles Or Fibres Consisting Of Wood Or Other Lignocellulosic Or Like Organic Material ",
	"B28B": "Shaping Clay Or Other Ceramic Compositions; Shaping Slag; Shaping Mixtures Containing Cementitious Material, E.G. Plaster ",
	"B28C": "Preparing Clay; Producing Mixtures Containing Clay Or Cementitious Material, E.G. Plaster ",
	"B28D": "Working Stone Or Stone-Like Materials",
	"B29B": "Preparation Or Pretreatment Of The Material To Be Shaped; Making Granules Or Preforms; Recovery Of Plastics Or Other Constituents Of Waste Material Containing Plastics",
	"B29C": "Shaping Or Joining Of Plastics; Shaping Of Material In A Plastic State, Not Otherwise Provided For; After-Treatment Of The Shaped Products, E.G. Repairing ",
	"B29D": "Producing Particular Articles From Plastics Or From Substances In A Plastic State ",
	"B29K": "Indexing Scheme Associated With Subclasses B29B, B29C Or B29D, Relating To Moulding Materials Or To Materials For ; Moulds, ;  Reinforcements, Fillers Or Preformed Parts, E.G. Inserts",
	"B29L": "Indexing Scheme Associated With Subclass B29C, Relating To Particular Articles",
	"B30B": "Presses In General ",
	"B31B": "Making Containers Of Paper, Cardboard Or Material Worked In A Manner Analogous To Paper ",
	"B31C": "Making Wound Articles, E.G. Wound Tubes, Of Paper, Cardboard Or Material Worked In A Manner Analogous To Paper",
	"B31D": "Making Articles Of Paper, Cardboard Or Material Worked In A Manner Analogous To Paper, Not Provided For In Subclasses B31B Or B31C ",
	"B31F": "Mechanical Working Or Deformation Of Paper, Cardboard Or Material Worked In A Manner Analogous To Paper ",
	"B32B": "Layered Products, I.E. Products Built-Up Of Strata Of Flat Or Non-Flat, E.G. Cellular Or Honeycomb, Form",
	"B33Y": "Additive Manufacturing, I.E. Manufacturing Of Three-Dimensional [3-D] Objects By Additive Deposition, Additive Agglomeration Or Additive Layering, E.G. By 3-D Printing, Stereolithography Or Selective Laser Sintering",
	"B41B": "Machines Or Accessories For Making, Setting, Or Distributing Type; Type; Photographic Or Photoelectric Composing Devices ",
	"B41C": "Processes For The Manufacture Or Reproduction Of Printing Surfaces ",
	"B41D": "Apparatus For The Mechanical Reproduction Of Printing Surfaces For Stereotype Printing; Shaping Elastic Or Deformable Material To Form Printing Surfaces ",
	"B41F": "Printing Machines Or Presses ",
	"B41G": "Apparatus For Bronze Printing, Line Printing, Or For Bordering Or Edging Sheets Or Like Articles; Auxiliary For Perforating In Conjunction With Printing ",
	"B41J": "Typewriters; Selective Printing Mechanisms, ; E.G. Ink-Jet Printers, Thermal Printers; , I.E. Mechanisms Printing Otherwise Than From A Forme; Correction Of Typographical Errors ",
	"B41K": "Stamps; Stamping Or Numbering Apparatus Or Devices ",
	"B41L": "Apparatus Or Devices For Manifolding, Duplicating Or Printing For Office Or Other Commercial Purposes; Addressing Machines Or Like Series-Printing Machines ",
	"B41M": "Printing, Duplicating, Marking, Or Copying Processes; Colour Printing, ",
	"B41N": "Printing Plates Or Foils ; Materials For Surfaces Used In Printing Machines For Printing, Inking, Damping, Or The Like; Preparing Such Surfaces For Use And Conserving Them",
	"B41P": "Indexing Scheme Relating To Printing, Lining Machines, Typewriters, And To Stamps",
	"B42B": "Permanently Attaching Together Sheets, Quires Or Signatures Or Permanently Attaching Objects Thereto ",
	"B42C": "Bookbinding ",
	"B42D": "Books; Book Covers; Loose Leaves; Printed Matter Characterised By Identification Or Security Features; Printed Matter Of Special Format Or Style Not Otherwise Provided For; Devices For Use Therewith And Not Otherwise Provided For; Movable-Strip Writing Or Reading Apparatus",
	"B42F": "Sheets Temporarily Attached Together; Filing Appliances; File Cards; Indexing ",
	"B42P": "Indexing Scheme Relating To Books, Filing Appliances Or The Like",
	"B43K": "Implements For Writing Or Drawing ",
	"B43L": "Articles For Writing Or Drawing Upon; ; Writing Or Drawing Aids;;  Accessories For Writing Or Drawing ",
	"B43M": "Bureau Accessories Not Otherwise Provided For ",
	"B44B": "Machines, Apparatus Or Tools For Artistic Work, E.G. For Sculpturing, Guilloching, Carving, Branding, Inlaying ",
	"B44C": "Producing Decorative Effects ; Mosaics; Tarsia Work ; Paperhanging ",
	"B44D": "Painting Or Artistic Drawing, Not Otherwise Provided For; Preserving Paintings; Surface Treatment To Obtain Special Artistic Surface Effects Or Finishes ",
	"B44F": "Special Designs Or Pictures",
	"B60B": "Vehicle Wheels ; Castors; Axles For Wheels Or Castors; Increasing Wheel Adhesion",
	"B60C": "Vehicle Tyres; Tyre Inflation; Tyre Changing; Connecting Valves To Inflatable Elastic Bodies In General; Devices Or Arrangements Related To Tyres",
	"B60D": "Vehicle Connections ",
	"B60F": "Vehicles For Use Both On Rail And On Road; Amphibious Or Like Vehicles; Convertible Vehicles ",
	"B60G": "Vehicle Suspension Arrangements ",
	"B60H": "Arrangements Of Heating, Cooling, Ventilating Or Other Air-Treating Devices Specially Adapted For Passenger Or Goods Spaces Of Vehicles",
	"B60J": "Windows, Windscreens, Non-Fixed Roofs, Doors, Or Similar Devices For Vehicles; Removable External Protective Coverings Specially Adapted For Vehicles ",
	"B60K": "Arrangement Or Mounting Of Propulsion Units Or Of Transmissions In Vehicles; Arrangement Or Mounting Of Plural Diverse Prime-Movers In Vehicles; Auxiliary Drives For Vehicles; Instrumentation Or Dashboards For Vehicles; Arrangements In Connection With Cooling, Air Intake, Gas Exhaust Or Fuel Supply Of Propulsion Units In Vehicles",
	"B60L": "Propulsion Of Electrically-Propelled Vehicles ; Supplying Electric Power For Auxiliary Equipment Of Electrically-Propelled Vehicles ; Electrodynamic Brake Systems For Vehicles In General ; Magnetic Suspension Or Levitation For Vehicles; Monitoring Operating Variables Of Electrically-Propelled Vehicles; Electric Safety Devices For Electrically-Propelled Vehicles",
	"B60M": "Power Supply Lines, And Devices Along Rails, For Electrically- Propelled Vehicles ",
	"B60N": "Seats Specially Adapted For Vehicles; Vehicle Passenger Accommodation Not Otherwise Provided For",
	"B60P": "Vehicles Adapted For Load Transportation Or To Transport, To Carry, Or To Comprise Special Loads Or Objects ",
	"B60Q": "Arrangement Of Signalling Or Lighting Devices, The Mounting Or Supporting Thereof Or Circuits Therefor, For Vehicles In General",
	"B60R": "Vehicles, Vehicle Fittings, Or Vehicle Parts, Not Otherwise Provided For",
	"B60S": "Servicing, Cleaning, Repairing, Supporting, Lifting, Or Manoeuvring Of Vehicles, Not Otherwise Provided For",
	"B60T": "Vehicle Brake Control Systems Or Parts Thereof; Brake Control Systems Or Parts Thereof, In General ; Arrangement Of Braking Elements On Vehicles In General; Portable Devices For Preventing Unwanted Movement Of Vehicles; Vehicle Modifications To Facilitate Cooling Of Brakes",
	"B60V": "Air-Cushion Vehicles",
	"B60W": "Conjoint Control Of Vehicle Sub-Units Of Different Type Or Different Function; Control Systems Specially Adapted For Hybrid Vehicles; Road Vehicle Drive Control Systems For Purposes Not Related To The Control Of A Particular Sub-Unit",
	"B60Y": "Indexing Scheme Relating To Aspects Cross-Cutting Vehicle Technology",
	"B61B": "Railway Systems; Equipment Therefor Not Otherwise Provided For ",
	"B61C": "Locomotives; Motor Railcars ",
	"B61D": "Body Details Or Kinds Of Railway Vehicles ",
	"B61F": "Rail Vehicle Suspensions, E.G. Underframes, Bogies Or Arrangements Of Wheel Axles; Rail Vehicles For Use On Tracks Of Different Width; Preventing Derailing Of Rail Vehicles; Wheel Guards, Obstruction Removers Or The Like For Rail Vehicles ",
	"B61G": "Couplings; Draught And Buffing Appliances ",
	"B61H": "Brakes Or Other Retarding Devices Specially Adapted For Rail Vehicles; Arrangement Or Disposition Thereof In Rail Vehicles ",
	"B61J": "Shifting Or Shunting Of Rail Vehicles ",
	"B61K": "Auxiliary Equipment Specially Adapted For Railways, Not Otherwise Provided For ",
	"B61L": "Guiding Railway Traffic; Ensuring The Safety Of Railway Traffic ",
	"B62B": "Hand-Propelled Vehicles, E.G. Hand Carts Or Perambulators; Sledges ",
	"B62C": "Vehicles Drawn By Animals",
	"B62D": "Motor Vehicles; Trailers ",
	"B62H": "Cycle Stands; Supports Or Holders For Parking Or Storing Cycles; Appliances Preventing Or Indicating Unauthorized Use Or Theft Of Cycles; Locks Integral With Cycles; Devices For Learning To Ride Cycles",
	"B62J": "Cycle Saddles Or Seats; Auxiliary Devices Or Accessories Specially Adapted To Cycles And Not Otherwise Provided For, E.G. Article Carriers Or Cycle Protectors",
	"B62K": "Cycles; Cycle Frames; Cycle Steering Devices; Rider-Operated Terminal Controls Specially Adapted For Cycles; Cycle Axle Suspensions; Cycle Side-Cars, Forecars, Or The Like",
	"B62L": "Brakes Specially Adapted For Cycles ",
	"B62M": "Rider Propulsion Of Wheeled Vehicles Or Sledges; Powered Propulsion Of Sledges Or ; Single-Track;  Cycles; Transmissions Specially Adapted For Such Vehicles ",
	"B63B": "Ships Or Other Waterborne Vessels; Equipment For Shipping\u00a0 ",
	"B63C": "Launching, Hauling-Out, Or Dry-Docking Of Vessels; Life-Saving In Water; Equipment For Dwelling Or Working Under Water; Means For Salvaging Or Searching For Underwater Objects ",
	"B63G": "Offensive Or Defensive Arrangements On Vessels; Mine-Laying; Mine-Sweeping; Submarines; Aircraft Carriers ",
	"B63H": "Marine Propulsion Or Steering ",
	"B63J": "Auxiliaries On Vessels",
	"B64B": "Lighter-Than Air Aircraft",
	"B64C": "Aeroplanes; Helicopters ",
	"B64D": "Equipment For Fitting In Or To Aircraft; Flying Suits; Parachutes; Arrangements Or Mounting Of Power Plants Or Propulsion Transmissions In Aircraft",
	"B64F": "Ground Or Aircraft-Carrier-Deck Installations Specially Adapted For Use In Connection With Aircraft; Designing, Manufacturing, Assembling, Cleaning, Maintaining Or Repairing Aircraft, Not Otherwise Provided For; Handling, Transporting, Testing Or Inspecting Aircraft Components, Not Otherwise Provided For",
	"B64G": "Cosmonautics; Vehicles Or Equipment Therefor ",
	"B65B": "Machines, Apparatus Or Devices For, Or Methods Of, Packaging Articles Or Materials; Unpacking ",
	"B65C": "Labelling Or Tagging Machines, Apparatus, Or Processes ",
	"B65D": "Containers For Storage Or Transport Of Articles Or Materials, E.G. Bags, Barrels, Bottles, Boxes, Cans, Cartons, Crates, Drums, Jars, Tanks, Hoppers, Forwarding Containers; Accessories, Closures, Or Fittings Therefor; Packaging Elements; Packages",
	"B65F": "Gathering Or Removal Of Domestic Or Like Refuse ",
	"B65G": "Transport Or Storage Devices, E.G. Conveyors For Loading Or Tipping,\u00a0Shop Conveyor Systems Or\u00a0Pneumatic Tube Conveyors ",
	"B65H": "Handling Thin Or Filamentary Material, E.G. Sheets, Webs, Cables",
	"B66B": "Elevators; Escalators Or Moving Walkways ",
	"B66C": "Cranes; Load-Engaging Elements Or Devices For Cranes, Capstans, Winches, Or Tackles ",
	"B66D": "Capstans; Winches; Tackles, E.G. Pulley Blocks; Hoists ",
	"B66F": "Hoisting, Lifting, Hauling Or Pushing, Not Otherwise Provided For, E.G. Devices Which Apply A Lifting Or Pushing Force Directly To The Surface Of A Load ",
	"B67B": "Applying Closure Members To Bottles Jars, Or Similar Containers; Opening Closed Containers ",
	"B67C": "Cleaning, Filling With Liquids Or Semiliquids, Or Emptying, Of Bottles, Jars, Cans, Casks, Barrels, Or Similar Containers, Not Otherwise Provided For; Funnels",
	"B67D": "Dispensing, Delivering Or Transferring Liquids, Not Otherwise Provided For ",
	"B68B": "Harness; Devices Used In Connection Therewith; Whips Or The Like",
	"B68C": "Saddles; Stirrups",
	"B68F": "Making Articles From Leather, Canvas, Or The Like",
	"B68G": "Methods, Equipment, Or Machines For Use In Upholstering; Upholstery Not Otherwise Provided For",
	"B81B": "Microstructural Devices Or Systems, E.G. Micromechanical Devices ",
	"B81C": "Processes Or Apparatus Specially Adapted For The Manufacture Or Treatment Of Microstructural Devices Or Systems ",
	"B82B": "Nanostructures Formed By Manipulation Of Individual Atoms, Molecules, Or Limited Collections Of Atoms Or Molecules As Discrete Units; Manufacture Or Treatment Thereof",
	"B82Y": "Specific Uses Or Applications Of Nanostructures; Measurement Or Analysis Of Nanostructures; Manufacture Or Treatment Of Nanostructures",
	"B99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"C01B": "Non-Metallic Elements; Compounds Thereof; ; Metalloids Or Compounds Thereof Not Covered By Subclass C01C",
	"C01C": "Ammonia; Cyanogen; Compounds Thereof ",
	"C01D": "Compounds Of Alkali Metals, I.E. Lithium, Sodium, Potassium, Rubidium, Caesium, Or Francium ",
	"C01F": "Compounds Of The Metals Beryllium, Magnesium, Aluminium, Calcium, Strontium, Barium, Radium, Thorium, Or Of The Rare-Earth Metals ",
	"C01G": "Compounds Containing Metals Not Covered By Subclasses C01D Or C01F ",
	"C01P": "Indexing Scheme Relating To Structural And Physical Aspects Of Solid Inorganic Compounds",
	"C02F": "Treatment Of Water, Waste Water, Sewage, Or Sludge ",
	"C03B": "Manufacture, Shaping, Or Supplementary Processes",
	"C03C": "Chemical Composition Of Glasses, Glazes Or Vitreous Enamels; Surface Treatment Of Glass; Surface Treatment Of Fibres Or Filaments Made From Glass, Minerals Or Slags; Joining Glass To Glass Or Other Materials",
	"C04B": "Lime, Magnesia; Slag; Cements; Compositions Thereof, E.G. Mortars, Concrete Or Like Building Materials; Artificial Stone ; Ceramics ; Refractories; Treatment Of Natural Stone",
	"C05B": "Phosphatic Fertilisers",
	"C05C": "Nitrogenous Fertilisers",
	"C05D": "Inorganic Fertilisers Not Covered By Subclasses C05B, C05C; Fertilisers Producing Carbon Dioxide",
	"C05F": "Organic Fertilisers Not Covered By Subclasses C05B, C05C, E.G. Fertilisers From Waste Or Refuse ",
	"C05G": "Mixtures Of Fertilisers Covered Individually By Different Subclasses Of Class C05; Mixtures Of One Or More Fertilisers With Materials Not Having A Specific Fertilising Activity, E.G. Pesticides, Soil-Conditioners, Wetting Agents ; Fertilisers Characterised By Their Form",
	"C06B": "Explosives Or Thermic Compositions ; Manufacture Thereof; Use Of Single Substances As Explosives ",
	"C06C": "Detonating Or Priming Devices; Fuses ; Chemical Lighters; Pyrophoric Compositions",
	"C06D": "Means For Generating Smoke Or Mist; Gas-Attack Compositions; Generation Of Gas For Blasting Or Propulsion (Chemical Part) ",
	"C06F": "Matches; Manufacture Of Matches",
	"C07B": "General Methods Of Organic Chemistry; Apparatus Therefor ",
	"C07C": "Acyclic Or Carbocyclic Compounds",
	"C07D": "Heterocyclic Compounds",
	"C07F": "Acyclic, Carbocyclic Or Heterocyclic Compounds Containing Elements Other Than Carbon, Hydrogen, Halogen, Oxygen, Nitrogen, Sulfur, Selenium Or Tellurium ",
	"C07G": "Compounds Of Unknown Constitution",
	"C07H": "Sugars; Derivatives Thereof; Nucleosides; Nucleotides; Nucleic Acids ",
	"C07J": "Steroids ",
	"C07K": "Peptides ",
	"C08B": "Polysaccharides; Derivatives Thereof ",
	"C08C": "Treatment Or Chemical Modification Of Rubbers",
	"C08F": "Macromolecular Compounds Obtained By Reactions Only Involving Carbon-To-Carbon Unsaturated Bonds",
	"C08G": "Macromolecular Compounds Obtained Otherwise Than By Reactions Only Involving Unsaturated Carbon-To-Carbon Bonds",
	"C08H": "Derivatives Of Natural Macromolecular Compounds ",
	"C08J": "Working-Up; General Processes Of Compounding; After-Treatment Not Covered By Subclasses C08B, C08C, C08F, C08G Or C08H ",
	"C08K": "Use Of Inorganic Or Non-Macromolecular Organic Substances As Compounding Ingredients ",
	"C08L": "Compositions Of Macromolecular Compounds ",
	"C09B": "Organic Dyes Or Closely-Related Compounds For Producing Dyes ; , E.G. Pigments; Mordants; Lakes ",
	"C09C": "Treatment Of Inorganic Materials, Other Than Fibrous Fillers, To Enhance Their Pigmenting Or Filling Properties ; Preparation Of Carbon Black; ; Preparation Of Inorganic Materials Which Are No Single Chemical Compounds And Which Are Mainly Used As Pigments Or Fillers",
	"C09D": "Coating Compositions, E.G. Paints, Varnishes Or Lacquers; Filling Pastes; Chemical Paint Or Ink Removers; Inks; Correcting Fluids; Woodstains; Pastes Or Solids For Colouring Or Printing; Use Of Materials Therefor ",
	"C09F": "Natural Resins; French Polish; Drying-Oils; Driers (Siccatives); Turpentine",
	"C09G": "Polishing Compositions ; Ski Waxes",
	"C09H": "Preparation Of Glue Or Gelatine",
	"C09J": "Adhesives; Non-Mechanical Aspects Of Adhesive Processes In General; Adhesive Processes Not Provided For Elsewhere; Use Of Materials As Adhesives ",
	"C09K": "Materials For Miscellaneous Applications, Not Provided For Elsewhere",
	"C10B": "Destructive Distillation Of Carbonageous Materials For Production Of Gas, Coke, Tar, Or Similar Materials ",
	"C10C": "Working-Up Pitch, Asphalt, Bitumen, Tar; Pyroligneous Acid ",
	"C10F": "Drying Or Working-Up Of Peat",
	"C10G": "Cracking Hydrocarbon Oils; Production Of Liquid Hydrocarbon Mixtures, E.G. By Destructive Hydrogenation, Oligomerisation, Polymerisation ; Recovery Of Hydrocarbon Oils From Oil-Shale, Oil-Sand, Or Gases; Refining Mixtures Mainly Consisting Of Hydrocarbons; Reforming Of Naphtha; Mineral Waxes ",
	"C10H": "Production Of Acetylene By Wet Methods ",
	"C10J": "Production Of Producer Gas, Water-Gas, Synthesis Gas From Solid Carbonaceous Material, Or Mixtures Containing These Gases ; Carburetting Air Or Other Gases",
	"C10K": "Purifying Or Modifying The Chemical Composition Of Combustible Gases Containing Carbon Monoxide",
	"C10L": "Fuels Not Otherwise Provided For ; Natural Gas; Synthetic Natural Gas Obtained By Processes Not Covered By Subclasses C10G, C10K; Liquefied Petroleum Gas; Adding Materials To Fuels Or Fires To Reduce Smoke Or Undesirable Deposits Or To Facilitate Soot Removal; Firelighters",
	"C10M": "Lubricating Compositions ; Use Of Chemical Substances Either Alone Or As Lubricating Ingredients In A Lubricating Composition ",
	"C10N": "Indexing Scheme Associated With Subclass C10M Relating To Lubricating Compositions",
	"C11B": "Producing, E.G. By Pressing Raw Materials Or By Extraction From Waste Materials, Refining Or Preserving Fats, Fatty Substances, E.G. Lanolin, Fatty Oils Or Waxes; Essential Oils; Perfumes ",
	"C11C": "Fatty Acids From Fats, Oils Or Waxes; Candles; Fats, Oils Or Fatty Acids By Chemical Modification Of Fats, Oils, Or Fatty Acids Obtained Therefrom",
	"C11D": "Detergent Compositions ; Use Of Single Substances As Detergents; Soap Or Soap-Making; Resin Soaps; Recovery Of Glycerol",
	"C12C": "Beer; Preparation Of Beer By Fermentation ; Preparation Of Malt For Making Beer; Preparation Of Hops For Making Beer",
	"C12F": "Recovery Of By-Products Of Fermented Solutions ; Denatured Alcohol; Preparation Thereof",
	"C12G": "Wine; Preparation Thereof; Alcoholic Beverages ; Preparation Of Alcoholic Beverages Not Provided For In Subclasses C12C Or C12H",
	"C12H": "Pasteurisation, Sterilisation, Preservation, Purification, Clarification Or Ageing Of Alcoholic Beverages; Methods For Altering The Alcohol Content Of Fermented Solutions Or Alcoholic Beverages ",
	"C12J": "Vinegar; Preparation Or Purification Thereof",
	"C12L": "Pitching Or Depitching Machines; Cellar Tools ",
	"C12M": "Apparatus For Enzymology Or Microbiology; Apparatus For Culturing Microorganisms For Producing Biomass, For Growing Cells Or For Obtaining Fermentation Or Metabolic Products, I.E. Bioreactors Or Fermenters",
	"C12N": "Microorganisms Or Enzymes; Compositions Thereof; Propagating, Preserving, Or Maintaining Microorganisms; Mutation Or Genetic Engineering; Culture Media ",
	"C12P": "Fermentation Or Enzyme-Using Processes To Synthesise A Desired Chemical Compound Or Composition Or To Separate Optical Isomers From A Racemic Mixture ",
	"C12Q": "Measuring Or Testing Processes Involving Enzymes, Nucleic Acids Or Microorganisms ; Compositions Or Test Papers Therefor; Processes Of Preparing Such Compositions; Condition-Responsive Control In Microbiological Or Enzymological Processes",
	"C12R": "Indexing Scheme Associated With Subclasses C12C - C12Q, Relating To Microorganisms",
	"C12Y": "Enzymes",
	"C13B": "Production Of Sucrose; Apparatus Specially Adapted Therefor ",
	"C13K": "Saccharides Obtained From Natural Sources Or By Hydrolysis Of Naturally Occurring Disaccharides, Oligosaccharides Or Polysaccharides ",
	"C14B": "Mechanical Treatment Or Processing Of Skins, Hides Or Leather In General; Pelt-Shearing Machines; Intestine-Splitting Machines ",
	"C14C": "Chemical Treatment Of Hides, Skins Or Leather, E.G. Tanning, Impregnating, Finishing; Apparatus Therefor; Compositions For Tanning ",
	"C21B": "Manufacture Of Iron Or Steel ",
	"C21C": "Processing Of Pig-Iron, E.G. Refining, Manufacture Of Wrought-Iron Or Steel; Treatment In Molten State Of Ferrous Alloys ",
	"C21D": "Modifying The Physical Structure Of Ferrous Metals; General Devices For Heat Treatment Of Ferrous Or Non-Ferrous Metals Or Alloys; Making Metal Malleable, E.G. By Decarburisation Or Tempering ",
	"C22B": "Production And Refining Of Metals ; Pretreatment Of Raw Materials",
	"C22C": "Alloys ",
	"C22F": "Changing The Physical Structure Of Non-Ferrous Metals And Non-Ferrous Alloys ",
	"C23C": "Coating Metallic Material; Coating Material With Metallic Material; Surface Treatment Of Metallic Material By Diffusion Into The Surface, By Chemical Conversion Or Substitution; Coating By Vacuum Evaporation, By Sputtering, By Ion Implantation Or By Chemical Vapour Deposition, In General ",
	"C23D": "Enamelling Of, Or Applying A Vitreous Layer To, Metals ",
	"C23F": "Non-Mechanical Removal Of Metallic Material From Surface ; Inhibiting Corrosion Of Metallic Material Or Incrustation In General; Multi-Step Processes For Surface Treatment Of Metallic Material Involving At Least One Process Provided For In Class C23 And At Least One Process Covered By Subclass C21D Or C22F Or Class C25",
	"C23G": "Cleaning Or Degreasing Of Metallic Material By Chemical Methods Other Than Electrolysis ",
	"C25B": "Electrolytic Or Electrophoretic Processes For The Production Of Compounds Or Non-Metals; Apparatus Therefor ",
	"C25C": "Processes For The Electrolytic Production, Recovery Or Refining Of Metals; Apparatus Therefor",
	"C25D": "Processes For The Electrolytic Or Electrophoretic Production Of Coatings; Electroforming; Apparatus Therefor",
	"C25F": "Processes For The Electrolytic Removal Of Materials From Objects; Apparatus Therefor",
	"C30B": "Single-Crystal Growth ; Unidirectional Solidification Of Eutectic Material Or Unidirectional Demixing Of Eutectoid Material; Refining By Zone-Melting Of Material ; Production Of A Homogeneous Polycrystalline Material With Defined Structure ; Single Crystals Or Homogeneous Polycrystalline Material With Defined Structure; After-Treatment Of Single Crystals Or A Homogeneous Polycrystalline Material With Defined Structure ; Apparatus Therefor",
	"C40B": "Combinatorial Chemistry; Libraries, E.G. Chemical Libraries ",
	"C99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"D01B": "Mechanical Treatment Of Natural Fibrous Or Filamentary Material To Obtain Fibres Of Filaments, E.G. For Spinning ",
	"D01C": "Chemical Treatment Of Natural Filamentary Or Fibrous Material To Obtain Filaments Or Fibres For Spinning; Carbonising Rags To Recover Animal Fibres",
	"D01D": "Mechanical Methods Or Apparatus In The Manufacture Of Artificial Filaments, Threads, Fibres, Bristles Or Ribbons",
	"D01F": "Chemical Features In The Manufacture Of Artificial Filaments, Threads, Fibres, Bristles Or Ribbons; Apparatus Specially Adapted For The Manufacture Of Carbon Filaments",
	"D01G": "Preliminary Treatment Of Fibres, E.G. For Spinning ",
	"D01H": "Spinning Or Twisting ",
	"D02G": "Crimping Or Curling Fibres, Filaments, Threads, Or Yarns; Yarns Or Threads",
	"D02H": "Warping, Beaming Or Leasing",
	"D02J": "Finishing Or Dressing Of Filaments, Yarns, Threads, Cords, Ropes Or The Like ",
	"D03C": "Shedding Mechanisms; Pattern Cards Or Chains; Punching Of Cards; Designing Patterns",
	"D03D": "Woven Fabrics; Methods Of Weaving; Looms",
	"D03J": "Auxiliary Weaving Apparatus; Weavers' Tools; Shuttles",
	"D04B": "Knitting",
	"D04C": "Braiding Or Manufacture Of Lace, Including Bobbin-Net Or Carbonised Lace; Braiding Machines; Braid; Lace ",
	"D04D": "Trimmings; Ribbons, Tapes Or Bands, Not Otherwise Provided For ",
	"D04G": "Making Nets By Knotting Of Filamentary Material; Making Knotted Carpets Or Tapestries; Knotting Not Otherwise Provided For ",
	"D04H": "Making Textile Fabrics, E.G. From Fibres Or Filamentary Material ; Fabrics Made By Such Processes Or Apparatus, E.G. Felts, Non-Woven Fabrics; Cotton-Wool; Wadding ; ; Non-Woven Fabrics From Staple Fibres, Filaments Or Yarns, Bonded With At Least One Web-Like Material During Their Consolidation",
	"D05B": "Sewing ",
	"D05C": "Embroidering; Tufting ",
	"D05D": "Indexing Scheme Associated With Subclasses D05B And D05C, Relating To Sewing, Embroidering And Tufting",
	"D06B": "Treating Textile Materials Using Liquids, Gases Or Vapours ",
	"D06C": "Finishing, Dressing, Tentering Or Stretching Textile Fabrics",
	"D06F": "Laundering, Drying, Ironing, Pressing Or Folding Textile Articles",
	"D06G": "Mechanical Or Pressure Cleaning Of Carpets, Rugs, Sacks, Hides, Or Other Skin Or Textile Articles Or Fabrics; Turning Inside-Out Flexible Tubular Or Other Hollow Articles",
	"D06H": "Marking, Inspecting, Seaming Or Severing Textile Materials ",
	"D06J": "Pleating, Kilting Or Goffering Textile Fabrics Or Wearing Apparel ",
	"D06L": "Dry-Cleaning, Washing Or Bleaching Fibres, Filaments, Threads, Yarns, Fabrics, Feathers Or Made-Up Fibrous Goods; Bleaching Leather Or Furs",
	"D06M": "Treatment, Not Provided For Elsewhere In Class D06, Of Fibres, Threads, Yarns, Fabrics, Feathers Or Fibrous Goods Made From Such Materials",
	"D06N": "Wall, Floor, Or Like Covering Materials, E.G. Linoleum, Oilcloth, Artificial Leather, Roofing Felt, Consisting Of A Fibrous Web Coated With A Layer Of Macromolecular Material; Flexible Sheet Material Not Otherwise Provided For",
	"D06P": "Dyeing Or Printing Textiles; Dyeing Leather, Furs Or Solid Macromolecular Substances In Any Form",
	"D06Q": "Decorating Textiles ",
	"D07B": "Ropes Or Cables In General ",
	"D10B": "Indexing Scheme Associated With Sublasses Of Section D, Relating To Textiles",
	"D21B": "Fibrous Raw Materials Or Their Mechanical Treatment",
	"D21C": "Production Of Cellulose By Removing Non-Cellulose Substances From Cellulose-Containing Materials; Regeneration Of Pulping Liquors; Apparatus Therefor",
	"D21D": "Treatment Of The Materials Before Passing To The Paper-Making Machine",
	"D21F": "Paper-Making Machines; Methods Of Producing Paper Thereon",
	"D21G": "Calenders; Accessories For Paper-Making Machines ",
	"D21H": "Pulp Compositions; Preparation Thereof Not Covered By Subclasses D21C Or D21D; Impregnating Or Coating Of Paper; Treatment Of Finished Paper Not Covered By Class B31 Or Subclass D21G; Paper Not Otherwise Provided For",
	"D21J": "Fibreboard; Manufacture Of Articles From Cellulosic Fibrous Suspensions Or From Papier-Mache ",
	"D99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"E01B": "Permanent Way; Permanent-Way Tools; Machines For Making Railways Of All Kinds ",
	"E01C": "Construction Of, Or Surfaces For, Roads, Sports Grounds, Or The Like; Machines Or Auxiliary Tools For Construction Or Repair ",
	"E01D": "Construction Of Bridges, ; Elevated Roadways;  Or Viaducts; Assembly Of Bridges ",
	"E01F": "Additional Work, Such As Equipping Roads Or The Construction Of Platforms, Helicopter Landing Stages, Signs, Snow Fences, Or The Like",
	"E01H": "Street Cleaning; Cleaning Of Permanent Ways; Cleaning Beaches; Dispersing ; Or Preventing;  Fog In General ; Cleaning Street Or Railway Furniture Or Tunnel Walls",
	"E02B": "Hydraulic Engineering ",
	"E02C": "Ship-Lifting Devices Or Mechanisms",
	"E02D": "Foundations; Excavations; Embankments ; Underground Or Underwater Structures ",
	"E02F": "Dredging; Soil-Shifting ",
	"E03B": "Installations Or Methods For Obtaining, Collecting, Or Distributing Water ",
	"E03C": "Domestic Plumbing Installations For Fresh Water Or Waste Water ; Sinks",
	"E03D": "Water-Closets Or Urinals With Flushing Devices; Flushing Valves Therefor",
	"E03F": "Sewers; Cesspools",
	"E04B": "General Building Constructions; Walls, E.G. Partitions; Roofs; Floors; Ceilings; Insulation Or Other Protection Of Buildings ",
	"E04C": "Structural Elements; Building Materials ",
	"E04D": "Roof Coverings; Sky-Lights; Gutters; Roof-Working Tools ",
	"E04F": "Finishing Work On Buildings, E.G. Stairs, Floors ",
	"E04G": "Scaffolding; Forms; Shuttering; Building Implements Or Aids, Or Their Use; Handling Building Materials On The Site; Repairing, Breaking-Up Or Other Work On Existing Buildings",
	"E04H": "Buildings Or Like Structures For Particular Purposes; Swimming Or Splash Baths Or Pools; Masts; Fencing; Tents Or Canopies, In General ",
	"E05B": "Locks; Accessories Therefor; Handcuffs",
	"E05C": "Bolts Or Fastening Devices For Wings, Specially For Doors Or Windows ",
	"E05D": "Hinges Or Suspension Devices For Doors, Windows Or Wings ",
	"E05F": "Devices For Moving Wings Into Open Or Closed Position; Checks For Wings; Wing Fittings Not Otherwise Provided For, Concerned With The Functioning Of The Wing",
	"E05G": "Safes Or Strong-Rooms For Valuables; Bank Protection Devices; Safety Transaction Partitions ",
	"E05Y": "Indexing Scheme Relating To Hinges Or Other Suspension Devices For Doors, Windows Or Wings And Devices For Moving Wings Into Open Or Closed Position, Checks For Wings And Wing Fittings Not Otherwise Provided For, Concerned With The Functioning Of The Wing",
	"E06B": "Fixed Or Movable Closures For Openings In Buildings, Vehicles, Fences Or Like Enclosures In General, E.G. Doors, Windows, Blinds, Gates ",
	"E06C": "Ladders ",
	"E21B": "Earth Drilling, E.G. Deep Drilling ; Obtaining Oil, Gas, Water, Soluble Or Meltable Materials Or A Slurry Of Minerals From Wells",
	"E21C": "Mining Or Quarrying",
	"E21D": "Shafts; Tunnels; Galleries; Large Underground Chambers ",
	"E21F": "Safety Devices, Transport, Filling-Up, Rescue, Ventilation, Or Draining In Or Of Mines Or Tunnels",
	"E99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"F01B": "Machines Or Engines, In General Or Of Positive-Displacement Type, E.G. Steam Engines ",
	"F01C": "Rotary-Piston Or Oscillating-Piston Machines Or Engines ",
	"F01D": "Non-Positive Displacement Machines Or Engines, E.G. Steam Turbines ",
	"F01K": "Steam Engine Plants; Steam Accumulators; Engine Plants Not Otherwise Provided For; Engines Using Special Working Fluids Or Cycles ",
	"F01L": "Cyclically Operating Valves For Machines Or Engines",
	"F01M": "Lubricating Of Machines Or Engines In General; Lubricating Internal Combustion Engines; Crankcase Ventilating",
	"F01N": "Gas-Flow Silencers Or Exhaust Apparatus For Machines Or Engines In General; Gas-Flow Silencers Or Exhaust Apparatus For Internal Combustion Engines ",
	"F01P": "Cooling Of Machines Or Engines In General; Cooling Of Internal-Combustion Engines ",
	"F02B": "Internal-Combustion Piston Engines; Combustion Engines In General ",
	"F02C": "Gas-Turbine Plants; Air Intakes For Jet-Propulsion Plants; Controlling Fuel Supply In Air-Breathing Jet-Propulsion Plants ",
	"F02D": "Controlling Combustion Engines ",
	"F02F": "Cylinders, Pistons Or Casings, For Combustion Engines; Arrangements Of Sealings In Combustion Engines",
	"F02G": "Hot Gas Or Combustion-Product Positive-Displacement Engine Plants ; Use Of Waste Heat Of Combustion Engines; Not Otherwise Provided For",
	"F02K": "Jet-Propulsion Plants ",
	"F02M": "Supplying Combustion Engines In General With Combustible Mixtures Or Constituents Thereof",
	"F02N": "Starting Of Combustion Engines; Starting Aids For Such Engines, Not Otherwise Provided For",
	"F02P": "Ignition, Other Than Compression Ignition, For Internal-Combustion Engines; Testing Of Ignition Timing In Compression-Ignition Engines ",
	"F03B": "Machines Or Engines For Liquids ",
	"F03C": "Positive-Displacement Engines Driven By Liquids ",
	"F03D": "Wind Motors",
	"F03G": "Spring, Weight, Inertia Or Like Motors; Mechanical-Power Producing Devices Or Mechanisms, Not Otherwise Provided For Or Using Energy Sources Not Otherwise Provided For ",
	"F03H": "Producing A Reactive Propulsive Thrust, Not Otherwise Provided For ",
	"F04B": "Positive-Displacement Machines For Liquids; Pumps ",
	"F04C": "Rotary-Piston, Or Oscillating-Piston, Positive-Displacement Machines For Liquids ; Rotary-Piston, Or Oscillating-Piston, Positive-Displacement Pumps",
	"F04D": "Non-Positive-Displacement Pumps ",
	"F04F": "Pumping Of Fluid By Direct Contact Of Another Fluid Or By Using Inertia Of Fluid To Be Pumped ; Siphons ",
	"F05B": "Indexing Scheme Relating To Wind, Spring, Weight, Inertia Or Like Motors, To Machines Or Engines For Liquids Covered By Subclasses F03B, F03D And F03G",
	"F05C": "Indexing Scheme Relating To Materials, Material Properties Or Material Characteristics For Machines, Engines Or Pumps Other Than Non-Positive-Displacement Machines Or Engines",
	"F05D": "Indexing Scheme For Aspects Relating To Non-Positive-Displacement Machines Or Engines, Gas-Turbines Or Jet-Propulsion Plants",
	"F15B": "Systems Acting By Means Of Fluids In General; Fluid-Pressure Actuators, E.G. Servomotors; Details Of Fluid-Pressure Systems, Not Otherwise Provided For",
	"F15C": "Fluid-Circuit Elements Predominantly Used For Computing Or Control Purposes ",
	"F15D": "Fluid Dynamics, I.E. Methods Or Means For Influencing The Flow Of Gases Or Liquids ",
	"F16B": "Devices For Fastening Or Securing Constructional Elements Or Machine Parts Together, E.G. Nails, Bolts, Circlips, Clamps, Clips, Wedges, Joints Or Jointing ",
	"F16C": "Shafts; Flexible Shafts; Elements Or Crankshaft Mechanisms; Rotary Bodies Other Than Gearing Elements; Bearings",
	"F16D": "Couplings For Transmitting Rotation; Clutches; Brakes",
	"F16F": "Springs; Shock-Absorbers; Means For Damping Vibration",
	"F16G": "Belts, Cables, Or Ropes, Predominantly Used For Driving Purposes; Chains; Fittings Predominantly Used Therefor",
	"F16H": "Gearing",
	"F16J": "Pistons ; Cylinders; Sealings",
	"F16K": "Valves; Taps; Cocks; Actuating-Floats; Devices For Venting Or Aerating ",
	"F16L": "Pipes; Joints Or Fittings For Pipes; Supports For Pipes, Cables Or Protective Tubing; Means For Thermal Insulation In General",
	"F16M": "Frames, Casings Or Beds Of Engines, Machines Or Apparatus, Not Specific To Engines, Machines Or Apparatus Provided For Elsewhere; Stands; Supports",
	"F16N": "Lubricating",
	"F16P": "Safety Devices In General; ; Safety Devices For Presses",
	"F16S": "Constructional Elements In General; Structures Built-Up From Such Elements, In General",
	"F16T": "Steam Traps Or Like Apparatus For Draining-Off Liquids From Enclosures Predominantly Containing Gases Or Vapours",
	"F17B": "Gas-Holders Of Variable Capacity ",
	"F17C": "Vessels For Containing Or Storing Compressed, Liquefied Or Solidified Gases; Fixed-Capacity Gas-Holders; Filling Vessels With, Or Discharging From Vessels, Compressed, Liquefied, Or Solidified Gases ",
	"F17D": "Pipe-Line Systems; Pipe-Lines ",
	"F21H": "Incandescent Mantles; Other Incandescent Bodies Heated By Combustion",
	"F21K": "Non-Electric Light Sources Using Luminescence; Light Sources Using Electrochemiluminescence; Light Sources Using Charges Of Combustible Material; Light Sources Using Semiconductor Devices As Light-Generating Elements; Light Sources Not Otherwise Provided For",
	"F21L": "Lighting Devices Or Systems Thereof, Being Portable Or Specially Adapted For Transportation",
	"F21S": "Non-Portable Lighting Devices; Systems Thereof; Vehicle Lighting Devices Specially Adapted For Vehicle Exteriors",
	"F21V": "Functional Features Or Details Of Lighting Devices Or Systems Thereof; Structural Combinations Of Lighting Devices With Other Articles, Not Otherwise Provided For",
	"F21W": "Indexing Scheme Associated With Subclasses F21K, F21L, F21S And F21V, Relating To Uses Or Applications Of Lighting Devices Or Systems",
	"F21Y": "Indexing Scheme Associated With Subclasses F21K, F21L, F21S And F21V, Relating To The Form Or The Kind Of The Light Sources Or Of The Colour Of The Light Emitted",
	"F22B": "Methods Of Steam Generation; Steam Boilers ",
	"F22D": "Preheating, Or Accumulating Preheated, Feed-Water For Steam Generation; Feed-Water Supply For Steam Generation; Controlling Water Level For Steam Generation; Auxiliary Devices For Promoting Water Circulation Within Steam Boilers",
	"F22G": "Superheating Of Steam ",
	"F23B": "Methods Or Apparatus For Combustion Using Only Solid Fuel ",
	"F23C": "Methods Or\u00a0Apparatus\u00a0For\u00a0Combustion\u00a0Using\u00a0Fluid\u00a0Fuel Or Solid Fuel Suspended In\u00a0 ; A Carrier Gas Or;  Air\u00a0 ",
	"F23D": "Burners",
	"F23G": "Cremation Furnaces; Consuming Waste Products By Combustion",
	"F23H": "Grates ; Cleaning Or Raking Grates",
	"F23J": "Removal Or Treatment Of Combustion Products Or Combustion Residues; Flues\u00a0 ",
	"F23K": "Feeding Fuel To Combustion Apparatus ",
	"F23L": "Supplying Air Or Non-Combustible Liquids Or Gases To Combustion Apparatus In General\u00a0 ; Valves Or Dampers Specially Adapted For Controlling Air Supply Or Draught In Combustion Apparatus ; Inducing Draught In Combustion Apparatus; Tops For Chimneys Or Ventilating Shafts; Terminals For Flues",
	"F23M": "Casings, Linings, Walls Or Doors Specially Adapted For Combustion Chambers, E.G. Firebridges; Devices For Deflecting Air, Flames Or Combustion Products In Combustion Chambers; Safety Arrangements Specially Adapted For Combustion Apparatus; Details Of Combustion Chambers, Not Otherwise Provided For",
	"F23N": "Regulating Or Controlling Combustion ",
	"F23Q": "Ignition ; Extinguishing-Devices",
	"F23R": "Generating Combustion Products Of High Pressure Or High Velocity, E.G. Gas-Turbine Combustion Chambers ",
	"F24B": "Domestic Stoves Or Ranges For Solid Fuels ; Implements For Use In Connection With Stoves Or Ranges",
	"F24C": "Domestic Stoves Or Ranges\u00a0 ; Details Of Domestic Stoves Or Ranges, Of General Application",
	"F24D": "Domestic- Or Space-Heating Systems, E.G. Central Heating Systems; Domestic Hot-Water Supply Systems; Elements Or Components Therefor ",
	"F24F": "Air-Conditioning; Air-Humidification; Ventilation; Use Of Air Currents For Screening ",
	"F24H": "Fluid Heaters, E.G. Water Or Air Heaters, Having Heat-Generating Means, E.G. Heat Pumps, In General ",
	"F24S": "Solar Heat Collectors; Solar Heat Systems ",
	"F24T": "Geothermal Collectors; Geothermal Systems",
	"F24V": "Collection, Production Or Use Of Heat Not Otherwise Provided For",
	"F25B": "Refrigeration Machines, Plants Or Systems; Combined Heating And Refrigeration Systems; Heat Pump Systems",
	"F25C": "Producing, Working Or Handling Ice",
	"F25D": "Refrigerators; Cold Rooms; Ice-Boxes; Cooling Or Freezing Apparatus Not Otherwise Provided For ",
	"F25J": "Liquefaction, Solidification Or Separation Of Gases Or Gaseous ; Or Liquefied Gaseous;  Mixtures By Pressure And Cold Treatment ; Or By Bringing Them Into The Supercritical State ",
	"F26B": "Drying Solid Materials Or Objects By Removing Liquid Therefrom ",
	"F27B": "Furnaces, Kilns, Ovens, Or Retorts In General; Open Sintering Or Like Apparatus",
	"F27D": "Details Or Accessories Of Furnaces, Kilns, Ovens, Or Retorts, In So Far As They Are Of Kinds Occurring In More Than One Kind Of Furnace ",
	"F27M": "Indexing Scheme Relating To Aspects Of The Charges Or Furnaces, Kilns, Ovens Or Retorts",
	"F28B": "Steam Or Vapour Condensers ",
	"F28C": "Heat-Exchange Apparatus, Not Provided For In Another Subclass, In Which The Heat-Exchange Media Come Into Direct Contact Without Chemical Interaction ",
	"F28D": "Heat-Exchange Apparatus, Not Provided For In Another Subclass, In Which The Heat-Exchange Media Do Not Come Into Direct Contact ",
	"F28F": "Details Of Heat-Exchange And Heat-Transfer Apparatus, Of General Application ",
	"F28G": "Cleaning Of Internal Or External Surfaces Of Heat-Exchange Or Heat-Transfer Conduits, E.G. Water Tubes Or Boilers ",
	"F41A": "Functional Features Or Details Common To Both Smallarms And Ordnance, E.G. Cannons; Mountings For Smallarms Or Ordnance",
	"F41B": "Weapons For Projecting Missiles Without Use Of Explosive Or Combustible Propellant Charge; Weapons Not Otherwise Provided For ",
	"F41C": "Smallarms, E.G. Pistols, Rifles ; Accessories Therefor",
	"F41F": "Apparatus For Launching Projectiles Or Missiles From Barrels, E.G. Cannons ; Launchers For Rockets Or Torpedoes; Harpoon Guns ",
	"F41G": "Weapon Sights; Aiming ",
	"F41H": "Armour; Armoured Turrets; Armoured Or Armed Vehicles; Means Of Attack Or Defence, E.G. Camouflage, In General",
	"F41J": "Targets; Target Ranges; Bullet Catchers ",
	"F42B": "Explosive Charges, E.G. For Blasting, Fireworks, Ammunition ",
	"F42C": "Ammunition Fuzes ; Arming Or Safety Means Therefor ",
	"F42D": "Blasting ",
	"F99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"G01B": "Measuring Length, Thickness Or Similar Linear Dimensions; Measuring Angles; Measuring Areas; Measuring Irregularities Of Surfaces Or Contours",
	"G01C": "Measuring Distances, Levels Or Bearings; Surveying; Navigation; Gyroscopic Instruments; Photogrammetry Or Videogrammetry ",
	"G01D": "Measuring Not Specially Adapted For A Specific Variable; Arrangements For Measuring Two Or More Variables Not Covered In A Single Other Subclass; Tariff Metering Apparatus; Measuring Or Testing Not Otherwise Provided For",
	"G01F": "Measuring Volume, Volume Flow, Mass Flow Or Liquid Level; Metering By Volume",
	"G01G": "Weighing ",
	"G01H": "Measurement Of Mechanical Vibrations Or Ultrasonic, Sonic Or Infrasonic Waves",
	"G01J": "Measurement Of Intensity, Velocity, Spectral Content, Polarisation, Phase Or Pulse Characteristics Of Infra-Red, Visible Or Ultra-Violet Light; Colorimetry; Radiation Pyrometry ",
	"G01K": "Measuring Temperature; Measuring Quantity Of Heat; Thermally-Sensitive Elements Not Otherwise Provided For ",
	"G01L": "Measuring Force, Stress, Torque, Work, Mechanical Power, Mechanical Efficiency, Or Fluid Pressure ",
	"G01M": "Testing Static Or Dynamic Balance Of Machines Or Structures; Testing Of Structures Or Apparatus, Not Otherwise Provided For",
	"G01N": "Investigating Or Analysing Materials By Determining Their Chemical Or Physical Properties ",
	"G01P": "Measuring Linear Or Angular Speed, Acceleration, Deceleration, Or Shock; Indicating Presence, Absence, Or Direction, Of Movement ",
	"G01Q": "Scanning-Probe Techniques Or Apparatus; Applications Of Scanning-Probe Techniques, E.G. Scanning Probe Microscopy [Spm]",
	"G01R": "Measuring Electric Variables; Measuring Magnetic Variables ",
	"G01S": "Radio Direction-Finding; Radio Navigation; Determining Distance Or Velocity By Use Of Radio Waves; Locating Or Presence-Detecting By Use Of The Reflection Or Reradiation Of Radio Waves; Analogous Arrangements Using Other Waves",
	"G01T": "Measurement Of Nuclear Or X-Radiation ",
	"G01V": "Geophysics; Gravitational Measurements; Detecting Masses Or Objects; Tags ",
	"G01W": "Meteorology ",
	"G02B": "Optical Elements, Systems Or Apparatus",
	"G02C": "Spectacles; Sunglasses Or Goggles Insofar As They Have The Same Features As Spectacles; Contact Lenses ",
	"G02F": "Optical Devices Or Arrangements For The Control Of Light By Modification Of The Optical Properties Of The Media Of The Elements Involved Therein; Non-Linear Optics; Frequency-Changing Of Light; Optical Logic Elements; Optical Analogue/Digital Converters",
	"G03B": "Apparatus Or Arrangements For Taking Photographs Or For Projecting Or Viewing Them; Apparatus Or Arrangements Employing Analogous Techniques Using Waves Other Than Optical Waves; Accessories Therefor ",
	"G03C": "Photosensitive Materials For Photographic Purposes ; Photographic Processes, E.G. Cine, X-Ray, Colour, Stereo-Photographic Processes; Auxiliary Processes In Photography ",
	"G03D": "Apparatus For Processing Exposed Photographic Materials ; Accessories Therefor ",
	"G03F": "Photomechanical Production Of Textured Or Patterned Surfaces, E.G. For Printing, For Processing Of Semiconductor Devices; Materials Therefor; Originals Therefor; Apparatus Specially Adapted Therefor; ",
	"G03G": "Electrography; Electrophotography; Magnetography ",
	"G03H": "Holographic Processes Or Apparatus ",
	"G04B": "Mechanically-Driven Clocks Or Watches; Mechanical Parts Of Clocks Or Watches In General; Time Pieces Using The Position Of The Sun, Moon Or Stars ",
	"G04C": "Electromechanical Clocks Or Watches ",
	"G04D": "Apparatus Or Tools Specially Designed For Making Or Maintaining Clocks Or Watches",
	"G04F": "Time-Interval Measuring ",
	"G04G": "Electronic Time-Pieces",
	"G04R": "Radio-Controlled Time-Pieces",
	"G05B": "Control Or Regulating Systems In General; Functional Elements Of Such Systems; Monitoring Or Testing Arrangements For Such Systems Or Elements ",
	"G05D": "Systems For Controlling Or Regulating Non-Electric Variables ",
	"G05F": "Systems For Regulating Electric Or Magnetic Variables ",
	"G05G": "Control Devices Or Systems Insofar As Characterised By Mechanical Features Only ",
	"G06C": "Digital Computers In Which All The Computation Is Effected Mechanically ",
	"G06D": "Digital Fluid-Pressure Computing Devices",
	"G06E": "Optical Computing Devices; ; Computing Devices Using Other Radiations With Similar Properties",
	"G06F": "Electric Digital Data Processing ",
	"G06G": "Analogue Computers ",
	"G06J": "Hybrid Computing Arrangements ",
	"G06K": "Graphical Data Reading ; Presentation Of Data; Record Carriers; Handling Record Carriers",
	"G06M": "Counting Mechanisms; Counting Of Objects Not Otherwise Provided For ",
	"G06N": "Computing Arrangements Based On Specific Computational Models",
	"G06Q": "Information and Communication Technology",
	// "G06Q": "Data Processing Systems Or Methods, Specially Adapted For Administrative, Commercial, Financial, Managerial, Supervisory Or Forecasting Purposes; Systems Or Methods Specially Adapted For Administrative, Commercial, Financial, Managerial, Supervisory Or Forecasting Purposes, Not Otherwise Provided For",
	"G06T": "Image Data Processing Or Generation",
	// "G06T": "Image Data Processing Or Generation, In General",
	"G06V": "Image Or Video Recognition Or Understanding",
	"G07B": "Ticket-Issuing Apparatus; Fare-Registering Apparatus; Franking Apparatus",
	"G07C": "Time Or Attendance Registers; Registering Or Indicating The Working Of Machines; Generating Random Numbers; Voting Or Lottery Apparatus; Arrangements, Systems Or Apparatus For Checking Not Provided For Elsewhere",
	"G07D": "Handling Of Coins Or Valuable Papers, E.G. Testing, Sorting By Denominations, Counting, Dispensing, Changing Or Depositing",
	"G07F": "Coin-Freed Or Like Apparatus ",
	"G07G": "Registering The Receipt Of Cash, Valuables, Or Tokens ",
	"G08B": "Signalling Or Calling Systems; Order Telegraphs; Alarm Systems",
	"G08C": "Transmission Systems For Measured Values, Control Or Similar Signals ",
	"G08G": "Traffic Control Systems ",
	"G09B": "Educational Or Demonstration Appliances; Appliances For Teaching, Or Communicating With, The Blind, Deaf Or Mute; Models; Planetaria; Globes; Maps; Diagrams ",
	"G09C": "Ciphering Or Deciphering Apparatus For Cryptographic Or Other Purposes Involving The Need For Secrecy",
	"G09D": "Railway Or Like Time Or Fare Tables; Perpetual Calendars ",
	"G09F": "Displaying; Advertising; Signs; Labels Or Name-Plates; Seals",
	"G09G": "Arrangements Or Circuits For Control Of Indicating Devices Using Static Means To Present Variable Information ",
	"G10B": "Organs, Harmoniums Or Similar Wind Musical Instruments With Associated Blowing Apparatus ",
	"G10C": "Pianos, Harpsichords, Spinets Or Similar Stringed Musical Instruments With One Or More Keyboards ",
	"G10D": "Stringed Musical Instruments; Wind Musical Instruments; Accordions Or Concertinas; Percussion Musical Instruments; Aeolian Harps; Singing-Flame Musical Instruments; Musical Instruments Not Otherwise Provided For ",
	"G10F": "Automatic Musical Instruments ",
	"G10G": "Representation Of Music; Recording Music In Notation Form; Accessories For Music Or Musical Instruments Not Otherwise Provided For, E.G. Supports ",
	"G10H": "Electrophonic Musical Instruments ",
	"G10K": "Sound-Producing Devices ; Methods Or Devices For Protecting Against, Or For Damping, Noise Or Other Acoustic Waves In General; Acoustics Not Otherwise Provided For",
	"G10L": "Speech Analysis Or Synthesis; Speech Recognition; Speech Or Voice Processing; Speech Or Audio Coding Or Decoding",
	"G11B": "Information Storage Based On Relative Movement Between Record Carrier And Transducer ",
	"G11C": "Static Stores ",
	"G12B": "Constructional Details Of Instruments, Or Comparable Details Of Other Apparatus, Not Otherwise Provided For",
	"G16B": "Bioinformatics, I.E. Information And Communication Technology [Ict] Specially Adapted For Genetic Or Protein-Related Data Processing In Computational Molecular Biology",
	"G16C": "Computational Chemistry; Chemoinformatics; Computational Materials Science",
	"G16H": "Healthcare Informatics, I.E. Information And Communication Technology [Ict] Specially Adapted For The Handling Or Processing Of Medical Or Healthcare Data",
	"G16Y": "Information And Communication Technology Specially Adapted For The Internet Of Things [Iot]",
	"G16Z": "Information And Communication Technology [Ict] Specially Adapted For Specific Application Fields, Not Otherwise Provided For",
	"G21B": "Fusion Reactors ",
	"G21C": "Nuclear Reactors ",
	"G21D": "Nuclear Power Plant",
	"G21F": "Protection Against X-Radiation, Gamma Radiation, Corpuscular Radiation Or Particle Bombardment; Treating Radioactively Contaminated Material; Decontamination Arrangements Therefor ",
	"G21G": "Conversion Of Chemical Elements; Radioactive Sources ",
	"G21H": "Obtaining Energy From Radioactive Sources; Applications Of Radiation From Radioactive Sources, Not Otherwise Provided For; Utilising Cosmic Radiation ",
	"G21J": "Nuclear Explosives; Applications Thereof ",
	"G21K": "Techniques For Handling Particles Or Ionising Radiation Not Otherwise Provided For; Irradiation Devices; Gamma Ray Or X-Ray Microscopes",
	"G99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"H01B": "Cables; Conductors; Insulators; Selection Of Materials For Their Conductive, Insulating Or Dielectric Properties ",
	"H01C": "Resistors",
	"H01F": "Magnets; Inductances; Transformers; Selection Of Materials For Their Magnetic Properties ",
	"H01G": "Capacitors; Capacitors, Rectifiers, Detectors, Switching Devices Or Light-Sensitive Devices, Of The Electrolytic Type ",
	"H01H": "Electric Switches; Relays; Selectors; Emergency Protective Devices ",
	"H01J": "Electric Discharge Tubes Or Discharge Lamps ",
	"H01K": "Electric Incandescent Lamps ",
	"H01L": "Semiconductor Devices; Electric Solid State Devices Not Otherwise Provided For ",
	"H01M": "Processes Or Means, E.G. Batteries, For The Direct Conversion Of Chemical Energy Into Electrical Energy",
	"H01P": "Waveguides; Resonators, Lines, Or Other Devices Of The Waveguide Type ",
	"H01Q": "Antennas, I.E. Radio Aerials ",
	"H01R": "Electrically-Conductive Connections; Structural Associations Of A Plurality Of Mutually-Insulated Electrical Connecting Elements; Coupling Devices; Current Collectors",
	"H01S": "Devices Using The Process Of Light Amplification By Stimulated Emission Of Radiation [Laser] To Amplify Or Generate Light; Devices Using Stimulated Emission Of Electromagnetic Radiation In Wave Ranges Other Than Optical",
	"H01T": "Spark Gaps; Overvoltage Arresters Using Spark Gaps; Sparking Plugs; Corona Devices; Generating Ions To Be Introduced Into Non-Enclosed Gases ",
	"H02B": "Boards, Substations, Or Switching Arrangements For The Supply Or Distribution Of Electric Power ",
	"H02G": "Installation Of Electric Cables Or Lines, Or Of Combined Optical And Electric Cables Or Lines ",
	"H02H": "Emergency Protective Circuit Arrangements ",
	"H02J": "Circuit Arrangements Or Systems For Supplying Or Distributing Electric Power; Systems For Storing Electric Energy",
	"H02K": "Dynamo-Electric Machines ",
	"H02M": "Apparatus For Conversion Between Ac And Ac, Between Ac And Dc, Or Between Dc And Dc, And For Use With Mains Or Similar Power Supply Systems; Conversion Of Dc Or Ac Input Power Into Surge Output Power; Control Or Regulation Thereof ",
	"H02N": "Electric Machines Not Otherwise Provided For",
	"H02P": "Control Or Regulation Of Electric Motors, Electric Generators Or Dynamo-Electric Converters; Controlling Transformers, Reactors Or Choke Coils",
	"H02S": "Generation Of Electric Power By Conversion Of Infra-Red Radiation, Visible Light Or Ultraviolet Light, E.G. Using Photovoltaic [Pv] Modules ",
	"H03B": "Generation Of Oscillations, Directly Or By Frequency-Changing, By Circuits Employing Active Elements Which Operate In A Non-Switching Manner; Generation Of Noise By Such Circuits ",
	"H03C": "Modulation ",
	"H03D": "Demodulation Or Transference Of Modulation From One Carrier To Another ",
	"H03F": "Amplifiers ",
	"H03G": "Control Of Amplification ",
	"H03H": "Impedance Networks, E.G. Resonant Circuits; Resonators ",
	"H03J": "Tuning Resonant Circuits; Selecting Resonant Circuits ",
	"H03K": "Pulse Technique ",
	"H03L": "Automatic Control, Starting, Synchronisation, Or Stabilisation Of Generators Of Electronic Oscillations Or Pulses ",
	"H03M": "Coding; Decoding; Code Conversion In General ",
	"H04B": "Transmission",
	"H04H": "Broadcast Communication ",
	"H04J": "Multiplex Communication ",
	"H04K": "Secret Communication; Jamming Of Communication",
	"H04L": "Transmission Of Digital Information, E.G. Telegraphic Communication ",
	"H04M": "Telephonic Communication ",
	"H04N": "Pictorial Communication, E.G. Television",
	"H04Q": "Selecting ",
	"H04R": "Loudspeakers, Microphones, Gramophone Pick-Ups Or Like Acoustic Electromechanical Transducers; Deaf-Aid Sets; Public Address Systems ",
	"H04S": "Stereophonic Systems\u00a0",
	"H04T": "Indexing Scheme Relating To Standards For Electric Communication Technique ",
	"H04W": "Wireless Communication Networks ",
	"H05B": "Electric Heating; Electric Light Sources Not Otherwise Provided For; Circuit Arrangements For Electric Light Sources, In General",
	"H05C": "Electric Circuits Or Apparatus Specially Designed For Use In Equipment For Killing, Stunning, Or Guiding Living Beings ",
	"H05F": "Static Electricity; Naturally-Occurring Electricity ",
	"H05G": "X-Ray Technique ",
	"H05H": "Plasma Technique ; Production Of Accelerated Electrically-Charged Particles Or Of Neutrons ; Production Or Acceleration Of Neutral Molecular Or Atomic Beams ",
	"H05K": "Printed Circuits; Casings Or Constructional Details Of Electric Apparatus; Manufacture Of Assemblages Of Electrical Components",
	"H99Z": "Subject Matter Not Otherwise Provided For In This Section",
	"Y02A": "Technologies For Adaptation To Climate Change",
	"Y02B": "Climate Change Mitigation Technologies Related To Buildings, E.G. Housing, House Appliances Or Related End-User Applications",
	"Y02C": "Capture, Storage, Sequestration Or Disposal Of Greenhouse Gases [Ghg]",
	"Y02D": "Climate Change Mitigation Technologies In Information And Communication Technologies [Ict], I.E. Information And Communication Technologies Aiming At The Reduction Of Their Own Energy Use",
	"Y02E": "Reduction Of Greenhouse Gas [Ghg] Emissions, Related To Energy Generation, Transmission Or Distribution",
	"Y02P": "Climate Change Mitigation Technologies In The Production Or Processing Of Goods",
	"Y02T": "Climate Change Mitigation Technologies Related To Transportation",
	"Y02W": "Climate Change Mitigation Technologies Related To Wastewater Treatment Or Waste Management",
	"Y04S": "Systems Integrating Technologies Related To Power Network Operation, Communication Or Information Technologies For Improving The Electrical Power Generation, Transmission, Distribution, Management Or Usage, I.E. Smart Grids",
	"Y10S": "Technical Subjects Covered By Former Uspc Cross-Reference Art Collections [Xracs] And Digests",
	"Y10T": "Technical Subjects Covered By Former Us Classification",
}
export const grantFieldCode2Name: { [fieldCode: string]: string } = {
	"30": "Agricultural, Veterinary And Food Sciences",
    "31": "Biological Sciences",
    "32": "Biomedical And Clinical Sciences",
    "33": "Built Environment And Design",
    "34": "Chemical Sciences",
    "35": "Commerce, Management, Tourism And Services",
    "36": "Creative Arts And Writing",
    "37": "Earth Sciences",
    "38": "Economics",
    "39": "Education",
    "40": "Engineering",
    "41": "Environmental Sciences",
    "42": "Health Sciences",
    "43": "History, Heritage And Archaeology",
    "44": "Human Society",
    "46": "Information And Computing Sciences",
    "47": "Language, Communication And Culture",
    "48": "Law And Legal Studies",
    "49": "Mathematical Sciences",
    "50": "Philosophy And Religious Studies",
    "51": "Physical Sciences",
    "52": "Psychology",

	"3001": "Agricultural Biotechnology",
	"3002": "Agriculture, Land And Farm Management",
	"3003": "Animal Production",
	"3004": "Crop And Pasture Production",
	"3005": "Fisheries Sciences",
	"3006": "Food Sciences",
	"3007": "Forestry Sciences",
	"3008": "Horticultural Production",
	"3009": "Veterinary Sciences",
	"3101": "Biochemistry And Cell Biology",
	"3102": "Bioinformatics And Computational Biology",
	"3103": "Ecology",
	"3104": "Evolutionary Biology",
	"3105": "Genetics",
	"3106": "Industrial Biotechnology",
	"3107": "Microbiology",
	"3108": "Plant Biology",
	"3109": "Zoology",
	"3201": "Cardiovascular Medicine And Haematology",
	"3202": "Clinical Sciences",
	"3203": "Dentistry",
	"3204": "Immunology",
	"3205": "Medical Biochemistry And Metabolomics",
	"3206": "Medical Biotechnology",
	"3207": "Medical Microbiology",
	"3208": "Medical Physiology",
	"3209": "Neurosciences",
	"3210": "Nutrition And Dietetics",
	"3211": "Oncology And Carcinogenesis",
	"3212": "Ophthalmology And Optometry",
	"3213": "Paediatrics",
	"3214": "Pharmacology And Pharmaceutical Sciences",
	"3215": "Reproductive Medicine",
	"3301": "Architecture",
	"3302": "Building",
	"3303": "Design",
	"3304": "Urban And Regional Planning",
	"3401": "Analytical Chemistry",
	"3402": "Inorganic Chemistry",
	"3403": "Macromolecular And Materials Chemistry",
	"3404": "Medicinal And Biomolecular Chemistry",
	"3405": "Organic Chemistry",
	"3406": "Physical Chemistry",
	"3407": "Theoretical And Computational Chemistry",
	"3501": "Accounting, Auditing And Accountability",
	"3502": "Banking, Finance And Investment",
	"3503": "Business Systems In Context",
	"3504": "Commercial Services",
	"3505": "Human Resources And Industrial Relations",
	"3506": "Marketing",
	"3507": "Strategy, Management And Organisational Behaviour",
	"3508": "Tourism",
	"3509": "Transportation, Logistics And Supply Chains",
	"3601": "Art History, Theory And Criticism",
	"3602": "Creative And Professional Writing",
	"3603": "Music",
	"3604": "Performing Arts",
	"3605": "Screen And Digital Media",
	"3606": "Visual Arts",
	"3701": "Atmospheric Sciences",
	"3702": "Climate Change Science",
	"3703": "Geochemistry",
	"3704": "Geoinformatics",
	"3705": "Geology",
	"3706": "Geophysics",
	"3707": "Hydrology",
	"3708": "Oceanography",
	"3709": "Physical Geography And Environmental Geoscience",
	"3801": "Applied Economics",
	"3802": "Econometrics",
	"3803": "Economic Theory",
	"3901": "Curriculum And Pedagogy",
	"3902": "Education Policy, Sociology And Philosophy",
	"3903": "Education Systems",
	"3904": "Specialist Studies In Education",
	"4001": "Aerospace Engineering",
	"4002": "Automotive Engineering",
	"4003": "Biomedical Engineering",
	"4004": "Chemical Engineering",
	"4005": "Civil Engineering",
	"4006": "Communications Engineering",
	"4007": "Control Engineering, Mechatronics And Robotics",
	"4008": "Electrical Engineering",
	"4009": "Electronics, Sensors And Digital Hardware",
	"4010": "Engineering Practice And Education",
	"4011": "Environmental Engineering",
	"4012": "Fluid Mechanics And Thermal Engineering",
	"4013": "Geomatic Engineering",
	"4014": "Manufacturing Engineering",
	"4015": "Maritime Engineering",
	"4016": "Materials Engineering",
	"4017": "Mechanical Engineering",
	"4018": "Nanotechnology",
	"4019": "Resources Engineering And Extractive Metallurgy",
	"4101": "Climate Change Impacts And Adaptation",
	"4102": "Ecological Applications",
	"4103": "Environmental Biotechnology",
	"4104": "Environmental Management",
	"4105": "Pollution And Contamination",
	"4106": "Soil Sciences",
	"4201": "Allied Health And Rehabilitation Science",
	"4202": "Epidemiology",
	"4203": "Health Services And Systems",
	"4204": "Midwifery",
	"4205": "Nursing",
	"4206": "Public Health",
	"4207": "Sports Science And Exercise",
	"4208": "Traditional, Complementary And Integrative Medicine",
	"4301": "Archaeology",
	"4302": "Heritage, Archive And Museum Studies",
	"4303": "Historical Studies",
	"4401": "Anthropology",
	"4402": "Criminology",
	"4403": "Demography",
	"4404": "Development Studies",
	"4405": "Gender Studies",
	"4406": "Human Geography",
	"4407": "Policy And Administration",
	"4408": "Political Science",
	"4409": "Social Work",
	"4410": "Sociology",
	"4601": "Applied Computing",
	"4602": "Artificial Intelligence",
	"4603": "Computer Vision And Multimedia Computation",
	"4604": "Cybersecurity And Privacy",
	"4605": "Data Management And Data Science",
	"4606": "Distributed Computing And Systems Software",
	"4607": "Graphics, Augmented Reality And Games",
	"4608": "Human-Centred Computing",
	"4609": "Information Systems",
	"4610": "Library And Information Studies",
	"4611": "Machine Learning",
	"4612": "Software Engineering",
	"4613": "Theory Of Computation",
	"4701": "Communication And Media Studies",
	"4702": "Cultural Studies",
	"4703": "Language Studies",
	"4704": "Linguistics",
	"4705": "Literary Studies",
	"4801": "Commercial Law",
	"4802": "Environmental And Resources Law",
	"4803": "International And Comparative Law",
	"4804": "Law In Context",
	"4805": "Legal Systems",
	"4806": "Private Law And Civil Obligations",
	"4807": "Public Law",
	"4901": "Applied Mathematics",
	"4902": "Mathematical Physics",
	"4903": "Numerical And Computational Mathematics",
	"4904": "Pure Mathematics",
	"4905": "Statistics",
	"5001": "Applied Ethics",
	"5002": "History And Philosophy Of Specific Fields",
	"5003": "Philosophy",
	"5004": "Religious Studies",
	"5005": "Theology",
	"5101": "Astronomical Sciences",
	"5102": "Atomic, Molecular And Optical Physics",
	"5103": "Classical Physics",
	"5104": "Condensed Matter Physics",
	"5105": "Medical And Biological Physics",
	"5106": "Nuclear And Plasma Physics",
	"5107": "Particle And High Energy Physics",
	"5108": "Quantum Physics",
	"5109": "Space Sciences",
	"5110": "Synchrotrons And Accelerators",
	"5201": "Applied And Developmental Psychology",
	"5202": "Biological Psychology",
	"5203": "Clinical And Health Psychology",
	"5204": "Cognitive And Computational Psychology",
	"5205": "Social And Personality Psychology"
}
// ===== field code to name (end) =====


// ===== university to grid id (start) =====
export const usR1Universities: PIViewTypes.UniversityGridIDs = {
	"Arizona State University": "grid.215654.1",
	"Auburn University": "grid.252546.2",
	"Baylor University": "grid.252890.4",
	"Binghamton University": "grid.264260.4",
	"Boston College": "grid.208226.c",
	"Boston University": "grid.189504.1",
	"Brandeis University": "grid.253264.4",
	"Brown University": "grid.40263.33",
	"California Institute of Technology": "grid.20861.3d",
	"Carnegie Mellon University": "grid.147455.6",
	"Case Western Reserve University": "grid.67105.35",
	"Clemson University": "grid.26090.3d",
	"Colorado School of Mines": "grid.254549.b",
	"Colorado State University": "grid.47894.36",
	"Columbia University": "grid.21729.3f",
	"Cornell University": "grid.5386.8",
	"Dartmouth College": "grid.254880.3",
	"Drexel University": "grid.166341.7",
	"Duke University": "grid.26009.3d",
	"Emory University": "grid.189967.8",
	"Florida International University": "grid.65456.34",
	"Florida State University": "grid.255986.5",
	"George Mason University": "grid.22448.38",
	"George Washington University": "grid.253615.6",
	"Georgetown University": "grid.213910.8",
	"Georgia Institute of Technology": "grid.213917.f",
	"Georgia State University": "grid.256304.6",
	"Harvard University": "grid.38142.3c",
	"Indiana University Bloomington": "grid.411377.7",
	"Iowa State University": "grid.34421.30",
	"Johns Hopkins University": "grid.21107.35",
	"Kansas State University": "grid.36567.31",
	"Kent State University": "grid.258518.3",
	"Louisiana State University": "grid.64337.35",
	"Massachusetts Institute of Technology": "grid.116068.8",
	"Michigan State University": "grid.17088.36",
	"Mississippi State University": "grid.260120.7",
	"Montana State University": "grid.41891.35",
	"New Jersey Institute of Technology": "grid.260896.3",
	"New York University": "grid.137628.9",
	"North Carolina State University": "grid.40803.3f",
	"North Dakota State University": "grid.261055.5",
	"Northeastern University": "grid.261112.7",
	"Northwestern University": "grid.16753.36",
	"Ohio University": "grid.20627.31",
	"Oklahoma State University": "grid.65519.3e",
	"Old Dominion University": "grid.261368.8",
	"Oregon State University": "grid.4391.f",
	"Pennsylvania State University": "grid.29857.31",
	"Princeton University": "grid.16750.35",
	"Purdue University West Lafayette": "grid.169077.e",
	"Rensselaer Polytechnic Institute": "grid.33647.35",
	"Rice University": "grid.21940.3e",
	"Rutgers, The State University of New Jersey": "grid.430387.b",
	"Stanford University": "grid.168010.e",
	"Stony Brook University": "grid.36425.36",
	"Syracuse University": "grid.264484.8",
	"Temple University": "grid.264727.2",
	"Texas A&M University": "grid.264756.4",
	"Texas Tech University": "grid.264784.b",
	"The Graduate Center, CUNY": "grid.253482.a",
	"The Ohio State University": "grid.261331.4",
	"The University of Texas at Arlington": "grid.267315.4",
	"The University of Texas at Austin": "grid.89336.37",
	"The University of Texas at Dallas": "grid.267323.1",
	"The University of Texas at El Paso": "grid.267324.6",
	"The University of Texas at San Antonio": "grid.215352.2",
	"Tufts University": "grid.429997.8",
	"Tulane University": "grid.265219.b",
	"University at Albany, State University of New York": "grid.265850.c",
	"University at Buffalo, State University of New York": "grid.273335.3",
	"University of Alabama": "grid.411015.0",
	"University of Alabama at Birmingham": "grid.265892.2",
	"University of Alabama in Huntsville": "grid.265893.3",
	"University of Arizona": "grid.134563.6",
	"University of Arkansas at Fayetteville": "grid.411017.2",
	"University of California, Berkeley": "grid.47840.3f",
	"University of California, Davis": "grid.27860.3b",
	"University of California, Irvine": "grid.266093.8",
	"University of California, Los Angeles": "grid.19006.3e",
	"University of California, Riverside": "grid.266097.c",
	"University of California, San Diego": "grid.266100.3",
	"University of California, Santa Barbara": "grid.133342.4",
	"University of California, Santa Cruz": "grid.205975.c",
	"University of Central Florida": "grid.170430.1",
	"University of Chicago": "grid.170205.1",
	"University of Cincinnati": "grid.24827.3b",
	"University of Colorado Boulder": "grid.266190.a",
	"University of Colorado Denver": "grid.241116.1",
	"University of Connecticut": "grid.63054.34",
	"University of Delaware": "grid.33489.35",
	"University of Denver": "grid.266239.a",
	"University of Florida": "grid.15276.37",
	"University of Georgia": "grid.213876.9",
	"University of Hawaii at Manoa": "grid.410445.0",
	"University of Houston": "grid.266436.3",
	"University of Illinois Urbana-Champaign": "grid.35403.31",
	"University of Illinois at Chicago": "grid.185648.6",
	"University of Iowa": "grid.214572.7",
	"University of Kansas": "grid.266515.3",
	"University of Kentucky": "grid.266539.d",
	"University of Louisiana at Lafayette": "grid.266621.7",
	"University of Louisville": "grid.266623.5",
	"University of Maine": "grid.21106.34",
	"University of Maryland, Baltimore County": "grid.266673.0",
	"University of Maryland, College Park": "grid.164295.d",
	"University of Massachusetts Amherst": "grid.266683.f",
	"University of Memphis": "grid.56061.34",
	"University of Miami": "grid.26790.3a",
	"University of Michigan–Ann Arbor": "grid.214458.e",
	"University of Minnesota": "grid.17635.36",
	"University of Mississippi": "grid.251313.7",
	"University of Missouri": "grid.134936.a",
	"University of Montana": "grid.253613.0",
	"University of Nebraska–Lincoln": "grid.24434.35",
	"University of Nevada Reno": "grid.266818.3",
	"University of Nevada, Las Vegas": "grid.272362.0",
	"University of New Hampshire": "grid.167436.1",
	"University of New Mexico": "grid.266832.b",
	"University of North Carolina at Chapel Hill": "grid.10698.36",
	"University of North Texas": "grid.266869.5",
	"University of Notre Dame": "grid.131063.6",
	"University of Oklahoma": "grid.266900.b",
	"University of Oregon": "grid.170202.6",
	"University of Pennsylvania": "grid.25879.31",
	"University of Pittsburgh": "grid.21925.3d",
	"University of Rochester": "grid.16416.34",
	"University of South Carolina": "grid.254567.7",
	"University of South Florida": "grid.170693.a",
	"University of Southern California": "grid.42505.36",
	"University of Southern Mississippi": "grid.267193.8",
	"University of Tennessee at Knoxville": "grid.411461.7",
	"University of Utah": "grid.223827.e",
	"University of Virginia": "grid.27755.32",
	"University of Washington": "grid.34477.33",
	"University of Wisconsin–Madison": "grid.14003.36",
	"University of Wisconsin–Milwaukee": "grid.267468.9",
	"Utah State University": "grid.53857.3c",
	"Vanderbilt University": "grid.152326.1",
	"Virginia Commonwealth University": "grid.224260.0",
	"Virginia Tech": "grid.438526.e",
	"Washington State University": "grid.30064.31",
	"Washington University in St. Louis": "grid.4367.6",
	"Wayne State University": "grid.254444.7",
	"West Virginia University": "grid.268154.c",
	"Yale University": "grid.47100.32"
  };
// ===== university to grid id (end) =====